import React, { useEffect, useRef, useState } from 'react'
import {
    Stack, Typography, Box, Grid, Pagination, MenuItem, Select, FormControl, InputLabel,
    Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Button, TextField,
    CircularProgress, Snackbar, Autocomplete, Card, CardContent, Chip, Table, TableHead, TableRow, TableCell, TableBody
} from '@mui/material'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import Analytics from '@mui/icons-material/Analytics';
import MuiAlert from '@mui/material/Alert'
import * as qs from 'qs';
import { useEvent } from '../../contexts/event.context'
import { useNavigation } from '../../contexts/navigation.context'
import { useAuth } from '../../contexts/auth.context';
import { useNavigate } from 'react-router-dom';
import TableCollapsible from '../../components/TableCollapsible'
import { format, parseISO, subYears } from 'date-fns'
import { validateBr } from 'js-brasil';
import * as yup from 'yup';
import { maskCNPJ, maskCPF2 } from '../../utils/mask'
import api from '../../services/api'
import XLSX from 'xlsx'
import { Pie, Bar } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Hotel } from '@mui/icons-material';
Chart.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

export default function Financeiro() {
    const [orders, setOrders] = useState([])
    const [dashData, setDataDash] = useState([])
    const navigation = useNavigation()
    const navigate = useNavigate()
    const { basePath } = useAuth();
    const [companies, setCompanies] = useState([])
    const page = useRef(1)
    const { events, getEvents, pagination, setPagination } = useEvent()
    const [selectedEvent, setSelectedEvent] = useState();
    const [selectedCompany, setSelectedCompany] = useState();
    const [selectedCompanyDocument, setSelectedCompanyDocument] = useState();
    const [selectedSubscriberName, setSelectedSubscriberName] = useState("");
    const [selectedStatus, setSelectedStatus] = useState();
    const [selectedExternal, setSelectedExternal] = useState();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteStatus, setDeleteStatus] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState()
    const [statusUpdate, setStatusUpdate] = useState('')
    const [loading, setLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState();
    const [listCategories, setListCategory] = useState([]);
    const [loadingCompany, setLoadingCompany] = useState(false)
    const [search, setSearch] = useState(false)
    const [renderExcel, setRenderExcel] = useState(false)
    const [stateAlert, setStateAlert] = React.useState({ status: false, type: 'success', msg: '' });
    const query = useRef()
    const [timer, setTimer] = useState(null)
    const searchCompany = useRef()
    const [editOrder, setEditOrder] = useState({});
    const [openExportDialog, setOpenExportDialog] = useState(false);
    const [selectedEventsToExport, setSelectedEventsToExport] = useState([]);
    const [selectedHospedagem, setSelectedHospedagem] = useState('all');
    const [cpfNovoInscrito, setCpfNovoInscrito] = useState('');
    const [novoInscrito, setNovoInscrito] = useState(null);
    const [buscandoNovoInscrito, setBuscandoNovoInscrito] = useState(false);
    const [subscriberParaSubstituir, setSubscriberParaSubstituir] = useState(null);
    const [openStatesDialog, setOpenStatesDialog] = useState(false);
    const [allStatesList, setAllStatesList] = useState([]);
    const [planUpdate, setPlanUpdate] = useState(null);
    const [planOrder, setPlanOrder] = useState(null);
    const [confirmBoletoDialog, setConfirmBoletoDialog] = useState(false);
    const [planChangeData, setPlanChangeData] = useState(null);
    const [loadingEvents, setLoadingEvents] = useState(false);
    const [hasMoreEvents, setHasMoreEvents] = useState(true);
    const [eventOptions, setEventOptions] = useState([])
    const pageEvents = useRef(1);
    const eventIdsRef = useRef(new Set());
    const [eventSearchText, setEventSearchText] = useState('');
    const eventSearchTimer = useRef(null);
    const listboxRef = useRef(null);
    const scrollPositionRef = useRef(0);

    query.current = qs.stringify({
        filters: {
            deleted: {
                $eq: false
            }
        },
        sort: ['createdAt:desc'],
        populate: '*',
        pagination: {
            pageSize: basePath == 'agip' || basePath == 'semper' ? 10 : 50,
            page: page.current,
        },
        encodeValuesOnly: true,

    });

    const status = ['PENDENTE', 'AGUARDANDO PAGAMENTO', 'PAGO', 'CORTESIA', 'EMPENHO', 'CANCELADA', 'ATRASADA', 'RECLAMADA', 'REEMBOLSADA'];

    async function loadMoreEvents() {
        if (!hasMoreEvents || loadingEvents) return;

        setLoadingEvents(true);
        try {
            const nextPage = pageEvents.current + 1;
            await getEvents(nextPage, 10, false);
            pageEvents.current = nextPage;
            
            // Verifica se chegou ao fim
            if (nextPage >= pagination.pageCount) {
                setHasMoreEvents(false);
            }
        } catch (error) {
            console.error('Erro ao carregar eventos:', error);
        } finally {
            setLoadingEvents(false);
        }
    }

    async function loadInitialEvents() {
        setLoadingEvents(true);
        try {
            await getEvents(1, 10, true);
            pageEvents.current = 1;
            setHasMoreEvents(true);
            eventIdsRef.current.clear();
        } catch (error) {
            console.error('Erro ao carregar eventos iniciais:', error);
        } finally {
            setLoadingEvents(false);
        }
    }

    async function searchEventsByText(searchText) {
        if (!searchText || searchText.trim().length < 2) {
            loadInitialEvents();
            return;
        }

        setLoadingEvents(true);
        try {
            let query = qs.stringify({
                filters: {
                    deleted: { $eq: false },
                    name: { $containsi: searchText }
                },
                pagination: { page: 1, pageSize: 20 },
                fields: ['name', 'city', 'count_subscribers', 'max_subscribers', 'date_initial', 'end_subscription', 'isActive', 'counter_hostings', 'typeForm'],
                populate: {
                    plans: { populate: '*' },
                    hostings: { populate: '*' },
                    collectors: { populate: '*' }
                },
                sort: ['createdAt:desc'],
                encodeValuesOnly: true,
            });

            const response = await api.get(`/events?${query}`);
            if (response.status === 200) {
                const formattedEvents = response.data.data.map((event) => {
                    return {
                        ...event,
                        attributes: {
                            ...event.attributes,
                            end_subscription: format(parseISO(event.attributes.end_subscription), 'dd/MM/yy'),
                            date_initial: format(parseISO(event.attributes.date_initial), 'dd/MM/yy'),
                            count_subscribers: `${event.attributes.count_subscribers}`,
                            isActive: event.attributes.isActive === true ? 'Aberto' : 'Encerrado'
                        }
                    };
                });

                eventIdsRef.current.clear();
                formattedEvents.forEach(event => eventIdsRef.current.add(event.id));
                setEventOptions(formattedEvents);
                pageEvents.current = 1;
                setHasMoreEvents(response.data.meta.pagination.pageCount > 1);
            }
        } catch (error) {
            console.error('Erro ao buscar eventos:', error);
        } finally {
            setLoadingEvents(false);
        }
    }
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const editOrderValidationSchema = yup.object().shape({
        company: yup.object().shape({
            document: yup.string()
                .test("is-cnpj", "CNPJ Inválido", value => validateBr.cnpj(value || ""))
                .required('CNPJ precisa ser preenchido'),
            social_reason: yup.string().required('Instituição precisa ser preenchida'),
            trade: yup.string().required('Nome Fantasia precisa ser preenchida'),
            address: yup.string().required('Endereço precisa ser preenchido'),
            cep: yup.string().required('CEP precisa ser preenchido'),
            city: yup.string().required('Cidade precisa ser preenchida'),
            state: yup.string().required('Estado precisa ser preenchido'),
            email: yup.string().email('E-mail inválido').required('Email precisa ser preenchido'),
        }),
        subscriber: yup.array().of(
            yup.object().shape({
                document: yup.string()
                    .test("is-cpf", "CPF Inválido", value => validateBr.cpf(value || ""))
                    .required('CPF precisa ser preenchido'),
                name: yup.string()
                    .min(8, 'Nome inválido (muito curto)')
                    .required('Nome precisa ser preenchido'),
                badge: yup.string().required(),
                gender: yup.string()
                    .oneOf(['M', 'F', 'Outro'], 'Gênero inválido')
                    .required('Gênero precisa ser preenchido'),
                email: yup.string()
                    .email('E-mail inválido')
                    .required('Email precisa ser preenchido'),
                whatsapp: yup.string()
                    .min(15, 'Celular inválido')
                    .required('Whatsapp precisa ser preenchido'),
                birth: yup.date('Data inválida')
                    .max(format(subYears(new Date(), 17), "yyyy-MM-dd"), 'Menor de 18 anos')
                    .min(format(subYears(new Date(), 100), "yyyy-MM-dd"), 'Maior de 100 anos')
                    .required('Data de Nascimento precisa ser preenchida'),
                office: yup.string()
                    .min(4, 'Minimo 4 letras')
                    .required('Cargo precisa ser preenchido'),
            })
        ),
        order: yup.object().shape({
            status: yup.string().required('Status precisa ser preenchido'),
            plan: yup.string().required('Tipo de Inscrição precisa ser preenchido'),
        }),
    });
    const availableGroups = [
        { id: 'rpps_pr', name: 'RPPS PR' },
        { id: 'rpps_invest', name: 'RPPS INVEST' },
        { id: 'rpps_beneficios', name: 'RPPS BENEFICIOS' },
        { id: 'rpps_contabil', name: 'RPPS CONTABIL' },
        { id: 'rpps_juridico', name: 'RPPS JURIDICO' },
        { id: 'rpps_presidentes', name: 'RPPS PRESIDENTES' },
        { id: 'rpps_comprev', name: 'RPPS COMPREV' }
    ];

    const columnsOrders = basePath == 'agip' || basePath == 'semper' ? [
        { Header: "N. Pedido", accessor: "transaction" },
        { Header: 'Evento', accessor: 'event' },
        { Header: "Instituição", accessor: "social_reason" },
        { Header: "Status", accessor: "status" },
        { Header: "Tipo de Inscrição", accessor: "plan" },
        { Header: "Forma de Pagamento", accessor: "payment_form" },
        { Header: "Quant.", accessor: "quantity" },
        { Header: "Total", accessor: "total" },
        { Header: "Data do Pedido", accessor: "createdAt" },
        { Header: "Ações", accessor: "actions" },
    ] : [
        { Header: "N. Pedido", accessor: "external_id" },
        { Header: "Inscrito", accessor: "subscriber" },
        { Header: 'Evento', accessor: 'event' },
        { Header: "Instituição", accessor: "social_reason" },
        { Header: "Hospedagem", accessor: "hosting" },
        { Header: "Status", accessor: "status" },
        { Header: "Tipo de Inscrição", accessor: "plan" },
        { Header: "Quant.", accessor: "quantity" },
        { Header: "Total", accessor: "total" },
        { Header: "Data do Pedido", accessor: "createdAt" },
        { Header: "Ações", accessor: "actions" },
    ];

    function formatOrders(orders) {
        return orders.map((order) => {
            const formattedOrder = {
                ...order,
                transaction: order.attributes.transaction,
                external_id: order.attributes.external_id || order.id,
                status: order.attributes.status,
                quantity: order.attributes.quantity,
                payment_form: order.attributes.payment_form,
                subscriber: order.attributes.subscribers?.data[0]
                    ? `${order.attributes.subscribers.data[0].attributes.name.toUpperCase()}${order.attributes.subscribers.data[0].attributes.isSubstitute
                        ? ` (Substituto de #${order.attributes.subscribers.data.find(sub =>
                            String(sub.id) === order.attributes.subscribers.data[0].attributes.isSubstitute
                        )?.attributes?.name.toUpperCase() || order.attributes.subscribers.data[0].attributes.isSubstitute})`
                        : ''
                    }`
                    : '',
                event: order.attributes.event?.data?.attributes?.name || '',
                hosting: order.attributes.hosting?.data?.attributes?.name ? `${order.attributes.hosting?.data?.attributes?.name} | ${order.attributes.hosting?.data?.attributes.type}` : 'Sem Hospedagem',
                plan: order.attributes.plan?.data?.attributes?.type || '',
                social_reason: order.attributes.company?.data?.attributes?.social_reason || 'Sem Instituição',
                createdAt: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm'),
                total: order.attributes.total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
            };
            return formattedOrder;
        });
    };

    async function handleSearch() {

        // Constrói os parâmetros de consulta
        const params = buildQueryParams({ event: selectedEvent, status: selectedStatus, company: selectedCompany, document: selectedCompanyDocument, category: selectedCategory, external_id: selectedExternal, subscriberName: selectedSubscriberName });

        try {
            setLoading(true);
            const response = await api.get(`/orders?${params}`);
            const data = response.data;
            if (data && data.data.length > 0) {
                const formattedOrders = formatOrders(data.data);
                setOrders(formattedOrders);
                setPagination(data.meta.pagination);
            } else {
                setOrders([]);
            }
        } catch (error) {
            console.error(error);
            setStateAlert({
                status: true,
                type: 'error',
                msg: error.response?.data?.error?.message || error.message,
            });
        } finally {
            setLoading(false);
        }
    };

    function buildQueryParams(filters) {
        const { event, status, company, document, category, external_id, subscriberName } = filters;
        const queryParams = {
            sort: ['createdAt:desc'],
            filters: {
                deleted: { $eq: false },
                ...(external_id && { external_id: { $containsi: external_id } }),
                ...(event && { event: { name: { $contains: event } } }),
                ...(status && { status: { $contains: status } }),
                ...((company || document) && {
                    company: {
                        social_reason: { $containsi: company },
                        ...(document && { document: document }),
                    },
                }),
                ...(selectedHospedagem == 'hosting' && {
                    hosting: { type: { $null: false } }
                }),
                ...(selectedHospedagem == 'nohosting' && {
                    hosting: { type: { $null: true } }
                }),
                ...(category && { plan: { type: { $contains: category } } }),
                ...(subscriberName && {
                    subscribers: {
                        name: { $containsi: subscriberName }
                    }
                }),
            },
            populate: {
                event: { fields: ['name'] },
                plan: { fields: ['*'] },
                company: { fields: ['*'] },
                hosting: { fields: ['*'] },
                subscribers: { fields: ['id', 'name', 'birth', 'document', 'email', 'whatsapp', 'office', 'badge', 'gender', 'isSubstitute'] },
            },
            pagination: {
                pageSize: basePath == 'agip' ? 10 : 50,
                page: page.current,
            },
            encodeValuesOnly: true,
        };

        return qs.stringify(queryParams, {
            skipNulls: true,
            skipUndefined: true,
            skipEmptyStrings: true,
        });
    };

    /*async function handleExcel() {
        if (orders.length <= 0) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Nenhum resultado para gerar planilha!` });
            return;
        };

        if (!selectedEvent) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Selecione um evento para gerar a planilha!` });
            return;
        };
        setRenderExcel(true);
        const event = selectedEvent;
        const status = selectedStatus;
        const company = selectedCompany;
        const document = selectedCompanyDocument
        const category = selectedCategory;
        const external_id = selectedExternal;
        const subscriberName = selectedSubscriberName;

        let page = 1;
        const pageSize = 100;
        let allOrders = [];

        try {
            while (true) {
                let params = {
                    sort: ['createdAt:desc'],
                    pagination: { page, pageSize },
                    filters: {
                        deleted: { $eq: false },
                        ...(external_id && { external_id: { $containsi: external_id } }),
                        ...(event && { event: { name: { $contains: event } } }),
                        ...(status && { status: { $contains: status } }),
                        ...((company || document) && {
                            company: {
                                social_reason: { $containsi: company },
                                ...(document && { document: document }),
                            },
                        }),
                        ...(selectedHospedagem == 'hosting' && {
                            hosting: { type: { $null: false } }
                        }),
                        ...(selectedHospedagem == 'nohosting' && {
                            hosting: { type: { $null: true } }
                        }),
                        ...(category && { plan: { type: { $contains: category } } }),
                        ...(subscriberName && {
                            subscribers: {
                                name: { $containsi: subscriberName }
                            }
                        }),
                    },
                    populate: {
                        event: { fields: ['name', 'due_date'] },
                        plan: { fields: ['type'] },
                        company: { fields: ['social_reason', 'state', 'city', 'document'] },
                        subscribers: { fields: ['document', 'gender', 'name', 'email', 'whatsapp', 'isSubstitute', 'tshirtSize', 'office', 'birth','groups'] },
                        hosting: { fields: ['name', 'type'] }
                    },
                    encodeValuesOnly: true
                };
                query.current = qs.stringify(params, {
                    skipNulls: false,
                    skipUndefined: false,
                    skipEmptyStrings: true
                });

                const response = await api.get(`/orders/?${query.current}`);
                const ordersData = response.data.data;

                if (!ordersData || ordersData.length === 0) break; // Sai do loop se não houver mais dados

                allOrders.push(...ordersData);
                page++; // Avança para a próxima página
            }
            // Transforma os dados para a planilha
            const sheetData = basePath == 'agip' ? allOrders.map(order => ({
                id: order.attributes.transaction,
                status: order.attributes.status,
                inscritos: order.attributes.quantity,
                instituicao: order.attributes.company?.data?.attributes?.social_reason || '',
                estado: order.attributes.company?.data?.attributes?.state || '',
                cidade: order.attributes.company?.data?.attributes?.city || '',
                cnpj: order.attributes.company?.data?.attributes?.document || '',
                pagamento: order.attributes.payment_form,
                categoria: order.attributes.plan?.data?.attributes?.type || '',
                total: order.attributes.total,
                data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm')
            })) :
                allOrders.flatMap(order => {
                    const subscribers = order.attributes.subscribers?.data || [];
                    // Se não houver inscritos, retorna uma linha vazia
                    if (subscribers.length === 0) {
                        return [{
                            id: order.attributes.external_id || order.attributes.transaction,
                            status: order.attributes.status == 'AGUARDANDO PAGAMENTO' ? 'NÃO PAGO' : order.attributes.status,
                            cpf: '',
                            nome: '',
                            genero: '',
                            email: '',
                            hospedagem: order.attributes.hosting?.data?.attributes?.name ? `${order.attributes.hosting?.data?.attributes?.name} | ${order.attributes.hosting?.data?.attributes.type}` : 'Sem Hospedagem',
                            instituicao: order.attributes.company?.data?.attributes?.social_reason || '',
                            estado: order.attributes.company?.data?.attributes?.state || '',
                            cidade: order.attributes.company?.data?.attributes?.city || '',
                            cnpj: order.attributes.company?.data?.attributes?.document || '',
                            pagamento: order.attributes.payment_form,
                            categoria: order.attributes.plan?.data?.attributes?.type || '',
                            total: order.attributes.total,
                            data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm'),
                            data_de_vencimento: order.attributes.bolecode?.data?.dado_boleto.dados_individuais_boleto[0]?.data_vencimento,
                            presente: order.attributes.subscribers?.data[0]?.attributes?.presence ? 'Presente' : 'Falta' || '',
                        }];
                    }
                    let view = subscribers.length < 2; // true = 1 inscrito | false = mais de 1 inscrito
                    // Para cada inscrito, gera uma linha
                    return subscribers.map(subscriber => (
                        !view ? {
                            id: order.attributes.external_id || order.attributes.transaction,
                            status: order.attributes.status == 'AGUARDANDO PAGAMENTO' ? 'NÃO PAGO' : order.attributes.status,
                            estado: order.attributes.company?.data?.attributes?.state || '',
                            cidade: order.attributes.company?.data?.attributes?.city || '',
                            cpf: subscriber.attributes?.document || '',
                            nome: subscriber.attributes.isSubstitute
                                ? `${String(subscriber.attributes.name).toUpperCase()} (Substituto de ${(() => {
                                    const original = order.attributes.subscribers?.data?.find(sub =>
                                        String(sub.id) === subscriber.attributes.isSubstitute
                                    );
                                    return original
                                        ? String(original.attributes.name).toUpperCase()
                                        : String(subscriber.attributes.isSubstitute).toUpperCase();
                                })()})`
                                : String(subscriber.attributes.name).toUpperCase() || '',
                            genero: subscriber.attributes?.gender || '',
                            data_nascimento: subscriber.attributes?.birth ? format(parseISO(subscriber.attributes?.birth), 'dd/MM/yyyy') : '',
                            email: subscriber.attributes?.email || '',
                            cargo: subscriber.attributes?.office || '',
                            whatsapp: subscriber.attributes?.whatsapp || '',
                            tamanho_camisa: subscriber.attributes?.tshirtSize || '',
                            grupos: subscriber.attributes?.groups && subscriber.attributes?.groups.length > 0 ? subscriber.attributes.groups.map(group => { 
                                const foundGroup = availableGroups.find(g => g.id === group);
                                return foundGroup ? foundGroup.name : group;
                            }).join(', ') : [],
                            hotel: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.name || 'Sem Hospedagem' : order.attributes.hosting?.data?.attributes?.name || 'Sem Hospedagem',
                            tipo: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.type || '' : order.attributes.hosting?.data?.attributes.type || '',
                            quarto: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.room : '',
                            entrada: order.attributes?.checkin ? format(parseISO(order.attributes?.checkin), 'dd/MM/yyyy') : '',
                            saida: order.attributes?.checkout ? format(parseISO(order.attributes?.checkout), 'dd/MM/yyyy') : '',
                            cnpj: order.attributes.company?.data?.attributes?.document || '',
                            instituicao: order.attributes.company?.data?.attributes?.social_reason || '',
                            categoria: order.attributes.plan?.data?.attributes?.type || '',
                            pagamento: order.attributes.payment_form,
                            total: order.attributes.total,
                            data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm'),
                            data_de_vencimento: order.attributes.bolecode?.data?.dado_boleto.dados_individuais_boleto[0]?.data_vencimento,
                            data_de_pagamento: order.attributes.status == 'AGUARDANDO PAGAMENTO' ? '' : format(parseISO(order.attributes.updatedAt), 'dd/MM/yy'),
                            presente: order.attributes.subscribers?.data[0]?.attributes?.presence ? 'Presente' : 'Falta' || '',
                        } : {
                            id: order.attributes.external_id || order.attributes.transaction,
                            status: order.attributes.status == 'AGUARDANDO PAGAMENTO' ? 'NÃO PAGO' : order.attributes.status,
                            estado: order.attributes.company?.data?.attributes?.state || '',
                            cidade: order.attributes.company?.data?.attributes?.city || '',
                            cpf: subscriber.attributes?.document || '',
                            nome: subscriber.attributes.isSubstitute
                                ? `${String(subscriber.attributes.name).toUpperCase()} (Substituto de ${(() => {
                                    const original = order.attributes.subscribers?.data?.find(sub =>
                                        String(sub.id) === subscriber.attributes.isSubstitute
                                    );
                                    return original
                                        ? String(original.attributes.name).toUpperCase()
                                        : subscriber.attributes.isSubstitute;
                                })()})`
                                : String(subscriber.attributes.name).toUpperCase() || '',
                            genero: subscriber.attributes?.gender || '',
                            data_nascimento: subscriber.attributes?.birth ? format(parseISO(subscriber.attributes?.birth), 'dd/MM/yyyy') : '',
                            email: subscriber.attributes?.email || '',
                            cargo: subscriber.attributes?.office || '',
                            whatsapp: subscriber.attributes?.whatsapp || '',
                            tamanho_camisa: subscriber.attributes?.tshirtSize || '',
                            grupos: subscriber.attributes?.groups && subscriber.attributes?.groups.length > 0 ? subscriber.attributes.groups.map(group => { 
                                const foundGroup = availableGroups.find(g => g.id === group);
                                return foundGroup ? foundGroup.name : group;
                            }).join(', ') : [],
                            hotel: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.name || 'Sem Hospedagem' : order.attributes.hosting?.data?.attributes?.name || 'Sem Hospedagem',
                            tipo: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.type || '' : order.attributes.hosting?.data?.attributes.type || '',
                            quarto: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.room : '',
                            entrada: order.attributes?.checkin ? format(parseISO(order.attributes?.checkin), 'dd/MM/yyyy') : '',
                            saida: order.attributes?.checkout ? format(parseISO(order.attributes?.checkout), 'dd/MM/yyyy') : '',
                            cnpj: order.attributes.company?.data?.attributes?.document || '',
                            instituicao: order.attributes.company?.data?.attributes?.social_reason || '',
                            categoria: order.attributes.plan?.data?.attributes?.type || '',
                            pagamento: order.attributes.payment_form,
                            total: order.attributes.total,
                            data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm'),
                            data_de_vencimento: order.attributes.bolecode?.data?.dado_boleto.dados_individuais_boleto[0]?.data_vencimento,
                            data_de_pagamento: order.attributes.status == 'AGUARDANDO PAGAMENTO' ? '' : format(parseISO(order.attributes.updatedAt), 'dd/MM/yy'),
                            presente: order.attributes.subscribers?.data[0]?.attributes?.presence ? 'Presente' : 'Falta' || '',
                        }));
                });

            // Gera e baixa o Excel
            const sheet = XLSX.utils.json_to_sheet(sheetData);
            const dateCols = ['data_de_vencimento'];
            sheetData.forEach((row, rowIdx) => {
                dateCols.forEach((col) => {
                    const colIdx = Object.keys(sheetData[0]).indexOf(col);
                    const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 1, c: colIdx });
                    if (sheet[cellRef] && row[col]) {
                        // Espera que row[col] esteja em formato 'dd/MM/yy' ou 'yyyy-MM-dd'
                        let dateObj;
                        if (row[col].includes('/')) {
                            // dd/MM/yy ou dd/MM/yyyy
                            let [day, month, year] = row[col].split('/');
                            if (year && year.length === 2) year = '20' + year; // converte para yyyy
                            dateObj = new Date(Number(year), Number(month) - 1, Number(day));
                        } else {
                            // yyyy-MM-dd
                            const [y, m, d] = row[col].split('-');
                            dateObj = new Date(Number(y), Number(m) - 1, Number(d));
                        }
                        sheet[cellRef].t = 'd';
                        sheet[cellRef].z = 'dd/mm/yyyy';
                        sheet[cellRef].v = dateObj;
                    }
                });
            });
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, sheet, 'inscricoes');

            setRenderExcel(false);
            return await XLSX.writeFile(workBook, `inscricoes-${selectedEvent}.xlsx`);
        } catch (error) {
            setRenderExcel(false);
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error}` })
            return
        }
    };*/

    async function handleExcel() {
        if (orders.length <= 0) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Nenhum resultado para gerar planilha!` });
            return;
        };

        if (!selectedEvent) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Selecione um evento para gerar a planilha!` });
            return;
        };
        setRenderExcel(true);
        const event = selectedEvent;
        const status = selectedStatus;
        const company = selectedCompany;
        const document = selectedCompanyDocument
        const category = selectedCategory;
        const external_id = selectedExternal;
        const subscriberName = selectedSubscriberName;

        // Verifica se é evento do tipo subscriber
        const selectedEventData = eventOptions.find(e => e.attributes?.name === selectedEvent);
        const isSubscriberEvent = selectedEventData?.attributes?.typeForm === 'subscriber';

        let page = 1;
        const pageSize = 100;
        let allOrders = [];

        try {
            while (true) {
                let params = {
                    sort: ['createdAt:desc'],
                    pagination: { page, pageSize },
                    filters: {
                        deleted: { $eq: false },
                        ...(external_id && { external_id: { $containsi: external_id } }),
                        ...(event && { event: { name: { $contains: event } } }),
                        ...(status && { status: { $contains: status } }),
                        ...((company || document) && {
                            company: {
                                social_reason: { $containsi: company },
                                ...(document && { document: document }),
                            },
                        }),
                        ...(selectedHospedagem == 'hosting' && {
                            hosting: { type: { $null: false } }
                        }),
                        ...(selectedHospedagem == 'nohosting' && {
                            hosting: { type: { $null: true } }
                        }),
                        ...(category && { plan: { type: { $contains: category } } }),
                        ...(subscriberName && {
                            subscribers: {
                                name: { $containsi: subscriberName }
                            }
                        }),
                    },
                    populate: {
                        event: { fields: ['id', 'name', 'due_date'] },
                        plan: { fields: ['type'] },
                        ...(!isSubscriberEvent && { company: { fields: ['social_reason', 'state', 'city', 'document'] } }),
                        subscribers: { fields: ['document', 'gender', 'name', 'email', 'whatsapp', 'isSubstitute', 'tshirtSize', 'office', 'birth', 'groups', 'state', 'city', 'neighborhood', 'street', 'cep', 'number', 'complement'] },
                        hosting: { fields: ['name', 'type'] }
                    },
                    encodeValuesOnly: true
                };
                query.current = qs.stringify(params, {
                    skipNulls: false,
                    skipUndefined: false,
                    skipEmptyStrings: true
                });

                const response = await api.get(`/orders/?${query.current}`);
                const ordersData = response.data.data;

                if (!ordersData || ordersData.length === 0) break;

                allOrders.push(...ordersData);
                page++;
            }

            // Contador global para quartos (persiste entre todas as orders) - usado apenas para agip
            const globalRoomCounters = { S: 1, D: 1, T: 1, Q: 1 };;
            const roomPairs = {}; // Mapeia orderId -> { D: currentNumber, count: 0 }

            // Cria um objeto base com todas as colunas de grupos inicializadas
            const createBaseRow = (orderData, subscriberData = null) => {
                if ((orderData.attributes.event.data.id == '24' || orderData.attributes.event.data.id == 24) && basePath != 'agip') {
                    const baseRow = {
                        // Para eventos subscriber, remove dados da empresa
                        ...(!isSubscriberEvent && {
                            estado: orderData.attributes.company?.data?.attributes?.state || '',
                            cidade: orderData.attributes.company?.data?.attributes?.city || '',
                        }),
                        // Para eventos subscriber, usa dados do subscriber
                        ...(isSubscriberEvent && {
                            estado: subscriberData?.attributes?.state.toUpperCase() || '',
                            cidade: subscriberData?.attributes?.city.toUpperCase() || '',
                        }),
                        whatsapp: subscriberData?.attributes?.whatsapp || '',
                        nome: subscriberData?.attributes.isSubstitute
                            ? `${String(subscriberData.attributes.name).toUpperCase()} (Substituto de ${(() => {
                                const original = orderData.attributes.subscribers?.data?.find(sub =>
                                    String(sub.id) === subscriberData.attributes.isSubstitute
                                );
                                return original
                                    ? String(original.attributes.name).toUpperCase()
                                    : String(subscriberData.attributes.isSubstitute).toUpperCase();
                            })()})`
                            : String(subscriberData?.attributes.name).toUpperCase() || '',
                    };

                    availableGroups.forEach(group => {
                        const columnName = group.name.replace(/\s+/g, '_').toLowerCase();
                        baseRow[columnName] = '';
                    });

                    // Preenche os grupos do subscriber
                    if (subscriberData?.attributes?.groups && subscriberData.attributes.groups.length > 0) {
                        subscriberData.attributes.groups.forEach(groupId => {
                            const foundGroup = availableGroups.find(g => g.id === groupId);
                            if (foundGroup) {
                                const columnName = foundGroup.name.replace(/\s+/g, '_').toLowerCase();
                                baseRow[columnName] = foundGroup.name;
                            }
                        });
                    }
                    baseRow.cargo = subscriberData?.attributes?.office || '';
                    // Para eventos subscriber, não inclui dados da instituição
                    if (!isSubscriberEvent) {
                        baseRow.instituicao = orderData.attributes.company?.data?.attributes?.social_reason.toUpperCase() || '';
                        baseRow.categoria = orderData.attributes.plan?.data?.attributes?.type.toUpperCase() || '';
                    }
                    baseRow.data_de_inscricao = format(parseISO(orderData.attributes.createdAt), 'dd/MM/yy HH:mm');

                    return baseRow;
                }

                const baseRow = {
                    id: orderData.attributes.external_id || orderData.attributes.transaction,
                    ...(!isSubscriberEvent && { status: orderData.attributes.status == 'AGUARDANDO PAGAMENTO' ? 'NÃO PAGO' : orderData.attributes.status }),
                    categoria: orderData.attributes.plan?.data?.attributes?.type.toUpperCase()  || '',
                    ...(!isSubscriberEvent && { total: orderData.attributes.total }),
                    data_de_inscricao: format(parseISO(orderData.attributes.createdAt), 'dd/MM/yy HH:mm'),
                    ...(!isSubscriberEvent && { data_de_vencimento: orderData.attributes.bolecode?.data?.dado_boleto.dados_individuais_boleto[0]?.data_vencimento || '' }),
                    ...(!isSubscriberEvent && { data_de_pagamento: orderData.attributes.status == 'PAGO' ? format(parseISO(orderData.attributes.updatedAt), 'dd/MM/yy') : '' }),
                    ...(!isSubscriberEvent && { presente: orderData.attributes.subscribers?.data[0]?.attributes?.presence ? 'Presente' : 'Falta' || '' }),
                };

                // Para eventos que não são do tipo subscriber, inclui dados da empresa
                if (!isSubscriberEvent) {
                    baseRow.estado = orderData.attributes.company?.data?.attributes?.state.toUpperCase() || subscriberData?.attributes?.state.toUpperCase() || '';
                    baseRow.cidade = orderData.attributes.company?.data?.attributes?.city.toUpperCase() || subscriberData?.attributes?.city.toUpperCase() || '';
                    baseRow.cnpj = orderData.attributes.company?.data?.attributes?.document || '';
                    baseRow.instituicao = orderData.attributes.company?.data?.attributes?.social_reason || '';
                } else {
                    // Para eventos subscriber, usa dados do subscriber
                    baseRow.endereco = subscriberData?.attributes?.street.toUpperCase() || '';
                    baseRow.numero = subscriberData?.attributes?.number || '';
                    baseRow.bairro = subscriberData?.attributes?.neighborhood || '';
                    baseRow.complemento = subscriberData?.attributes?.complement || '';
                    baseRow.cep = subscriberData?.attributes?.cep || '';
                    baseRow.estado = subscriberData?.attributes?.state.toUpperCase() || '';
                    baseRow.cidade = subscriberData?.attributes?.city.toUpperCase() || '';
                }

                if (subscriberData) {
                    baseRow.cpf = subscriberData.attributes?.document || '';
                    baseRow.nome = subscriberData.attributes.isSubstitute
                        ? `${String(subscriberData.attributes.name).toUpperCase()} (Substituto de ${(() => {
                            const original = orderData.attributes.subscribers?.data?.find(sub =>
                                String(sub.id) === subscriberData.attributes.isSubstitute
                            );
                            return original
                                ? String(original.attributes.name).toUpperCase()
                                : String(subscriberData.attributes.isSubstitute).toUpperCase();
                        })()})`
                        : String(subscriberData.attributes.name).toUpperCase() || '';
                    baseRow.genero = subscriberData.attributes?.gender || '';
                    baseRow.data_nascimento = subscriberData.attributes?.birth ? format(parseISO(subscriberData.attributes?.birth), 'dd/MM/yyyy') : '';
                    baseRow.email = subscriberData.attributes?.email || '';
                    baseRow.cargo = subscriberData.attributes?.office.toUpperCase() || '';
                    baseRow.whatsapp = subscriberData.attributes?.whatsapp || '';
                    (subscriberData.attributes?.tshirtSize && (baseRow.tamanho_camisa = subscriberData.attributes?.tshirtSize));

                    if (!isSubscriberEvent) {
                        // Dados de hospedagem
                        if (subscriberData.attributes?.hosting) {
                            baseRow.hotel = subscriberData.attributes.hosting.name.toUpperCase() || 'Sem Hospedagem';
                            baseRow.tipo = subscriberData.attributes.hosting.type.toUpperCase() || '';
                            baseRow.quarto = subscriberData.attributes.hosting.room || '';
                        } else if (orderData.attributes?.hosting) {
                            baseRow.hotel = orderData.attributes?.hosting?.data?.attributes?.name.toUpperCase() || 'Sem Hospedagem';
                            baseRow.tipo = orderData.attributes?.hosting?.data?.attributes?.type.toUpperCase() || '';
                            // Lógica de numeração de quartos apenas para agip
                            if (globalRoomCounters && roomPairs) {
                                const tipo = (orderData.attributes?.hosting?.data?.attributes?.type || '').toLowerCase();
                                const orderId = orderData.id;

                                if (tipo.includes('single')) {
                                    // Single: cada inscrito tem quarto único
                                    baseRow.quarto = `S${globalRoomCounters.S}`;
                                    globalRoomCounters.S++;
                                } else if (tipo.includes('duplo')) {
                                    // Duplo: cada order tem seus quartos, dois inscritos por quarto
                                    if (!roomPairs[orderId]) {
                                        roomPairs[orderId] = { D: globalRoomCounters.D, count: 0 };
                                        globalRoomCounters.D++;
                                    }
                                    baseRow.quarto = `D${roomPairs[orderId].D}`;
                                    roomPairs[orderId].count++;

                                    // Se já alocou 2 pessoas, próximo inscrito desta order vai para novo quarto
                                    if (roomPairs[orderId].count >= 2) {
                                        roomPairs[orderId].D = globalRoomCounters.D;
                                        roomPairs[orderId].count = 0;
                                        globalRoomCounters.D++;
                                    }
                                } else if (tipo.includes('triplo')) {
                                    if (!roomPairs[orderId]) {
                                        roomPairs[orderId] = { T: globalRoomCounters.T, count: 0 };
                                        globalRoomCounters.T++;
                                    }
                                    baseRow.quarto = `T${roomPairs[orderId].T}`;
                                    roomPairs[orderId].count++;

                                    if (roomPairs[orderId].count >= 3) {
                                        roomPairs[orderId].T = globalRoomCounters.T;
                                        roomPairs[orderId].count = 0;
                                        globalRoomCounters.T++;
                                    }
                                } else if (tipo.includes('quadruplo')) {
                                    if (!roomPairs[orderId]) {
                                        roomPairs[orderId] = { Q: globalRoomCounters.Q, count: 0 };
                                        globalRoomCounters.Q++;
                                    }
                                    baseRow.quarto = `Q${roomPairs[orderId].Q}`;
                                    roomPairs[orderId].count++;

                                    if (roomPairs[orderId].count >= 4) {
                                        roomPairs[orderId].Q = globalRoomCounters.Q;
                                        roomPairs[orderId].count = 0;
                                        globalRoomCounters.Q++;
                                    }
                                } else {
                                    baseRow.quarto = '';
                                }
                            } else {
                                baseRow.quarto = subscriberData?.attributes?.hosting?.room.toUpperCase() || '';
                            }
                        } else {
                            baseRow.hotel = orderData.attributes?.hosting?.data?.attributes?.name.toUpperCase() || 'Sem Hospedagem';
                            baseRow.tipo = orderData.attributes?.hosting?.data?.attributes?.type.toUpperCase() || '';
                            baseRow.quarto = '';
                        }

                        baseRow.entrada = orderData.attributes?.checkin ? format(parseISO(orderData.attributes?.checkin), 'dd/MM/yyyy') : '';
                        baseRow.saida = orderData.attributes?.checkout ? format(parseISO(orderData.attributes?.checkout), 'dd/MM/yyyy') : '';
                    }
                }

                return baseRow;
            };

            // Transforma os dados para a planilha
            const sheetData = basePath == 'semper' ?
                allOrders.map(order => {
                    const eventTypeForm = order.attributes.event?.data?.attributes?.typeForm;
                    const baseData = {
                        id: order.attributes.transaction,
                        status: order.attributes.status,
                        inscritos: order.attributes.quantity,
                        pagamento: order.attributes.payment_form,
                        categoria: order.attributes.plan?.data?.attributes?.type.toUpperCase() || '',
                        total: order.attributes.total,
                        data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm')
                    };

                    // Para eventos que não são do tipo subscriber, inclui dados da empresa
                    if (eventTypeForm !== 'subscriber') {
                        baseData.instituicao = order.attributes.company?.data?.attributes?.social_reason.toUpperCase() || '';
                        baseData.estado = order.attributes.company?.data?.attributes?.state.toUpperCase() || '';
                        baseData.cidade = order.attributes.company?.data?.attributes?.city.toUpperCase() || '';
                        baseData.cnpj = order.attributes.company?.data?.attributes?.document || '';
                    }

                    return baseData;
                }) :
                allOrders.flatMap(order => {
                    const subscribers = order.attributes.subscribers?.data || [];

                    if (subscribers.length === 0) {
                        return [createBaseRow(order)];
                    }

                    return subscribers.map(subscriber => createBaseRow(order, subscriber));
                });

            // Gera e baixa o Excel
            const sheet = XLSX.utils.json_to_sheet(sheetData);
            const dateCols = ['data_de_vencimento'];
            sheetData.forEach((row, rowIdx) => {
                dateCols.forEach((col) => {
                    const colIdx = Object.keys(sheetData[0]).indexOf(col);
                    const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 1, c: colIdx });
                    if (sheet[cellRef] && row[col]) {
                        let dateObj;
                        if (row[col].includes('/')) {
                            let [day, month, year] = row[col].split('/');
                            if (year && year.length === 2) year = '20' + year;
                            dateObj = new Date(Number(year), Number(month) - 1, Number(day));
                        } else {
                            const [y, m, d] = row[col].split('-');
                            dateObj = new Date(Number(y), Number(m) - 1, Number(d));
                        }
                        sheet[cellRef].t = 'd';
                        sheet[cellRef].z = 'dd/mm/yyyy';
                        sheet[cellRef].v = dateObj;
                    }
                });
            });
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, sheet, 'inscricoes');

            setRenderExcel(false);
            return await XLSX.writeFile(workBook, `inscricoes-${selectedEvent}.xlsx`);
        } catch (error) {
            setRenderExcel(false);
            console.log(error);
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error}` })
            return
        }
    };

    async function handleExportMultipleEvents(eventsToExport) {
        if (!eventsToExport || eventsToExport.length === 0) return;
        setRenderExcel(true);

        let allOrders = [];
        for (const event of eventsToExport) {
            let page = 1;
            const pageSize = 100;
            while (true) {
                let params = {
                    sort: ['createdAt:desc'],
                    pagination: { page, pageSize },
                    filters: {
                        deleted: { $eq: false },
                        event: { name: event.attributes.name },
                    },
                    populate: {
                        event: { fields: ['name', 'due_date'] },
                        plan: { fields: ['type'] },
                        company: { fields: ['social_reason', 'state', 'city', 'document'] },
                        subscribers: { fields: ['document', 'gender', 'name', 'email', 'isSubstitute', 'tshirtSize'] },
                        hosting: { fields: ['name', 'type'] }
                    },
                    encodeValuesOnly: true
                };
                const queryStr = qs.stringify(params, {
                    skipNulls: false,
                    skipUndefined: false,
                    skipEmptyStrings: true
                });
                const response = await api.get(`/orders/?${queryStr}`);
                const ordersData = response.data.data;
                if (!ordersData || ordersData.length === 0) break;
                allOrders.push(...ordersData);
                page++;
            }
        }
        // Transforme os dados para a planilha (igual ao seu handleExcel)
        const sheetData = basePath == 'agip' ? allOrders.map(order => ({
            evento: order.attributes.event?.data?.attributes?.name || '',
            id: order.attributes.transaction,
            status: order.attributes.status,
            inscritos: order.attributes.quantity,
            instituicao: order.attributes.company?.data?.attributes?.social_reason || '',
            estado: order.attributes.company?.data?.attributes?.state || '',
            cidade: order.attributes.company?.data?.attributes?.city || '',
            cnpj: order.attributes.company?.data?.attributes?.document || '',
            pagamento: order.attributes.payment_form,
            categoria: order.attributes.plan?.data?.attributes?.type || '',
            total: order.attributes.total,
            data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm')
        })) : allOrders.flatMap(order => {
            const subscribers = order.attributes.subscribers?.data || [];
            if (subscribers.length === 0) {
                return [{
                    evento: order.attributes.event?.data?.attributes?.name || '',
                    id: order.attributes.external_id || order.attributes.transaction,
                    status: order.attributes.status == 'AGUARDANDO PAGAMENTO' ? 'NÃO PAGO' : order.attributes.status,
                    cpf: '',
                    nome: '',
                    genero: '',
                    email: '',
                    hospedagem: order.attributes.hosting?.data?.attributes?.name ? `${order.attributes.hosting?.data?.attributes?.name} | ${order.attributes.hosting?.data?.attributes.type}` : 'Sem Hospedagem',
                    instituicao: order.attributes.company?.data?.attributes?.social_reason || '',
                    estado: order.attributes.company?.data?.attributes?.state || '',
                    cidade: order.attributes.company?.data?.attributes?.city || '',
                    cnpj: order.attributes.company?.data?.attributes?.document || '',
                    pagamento: order.attributes.payment_form,
                    categoria: order.attributes.plan?.data?.attributes?.type || '',
                    total: order.attributes.total,
                    data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm'),
                    data_de_vencimento: order.attributes.bolecode?.data?.dado_boleto.dados_individuais_boleto[0]?.data_vencimento || ''
                }];
            }
            let view = subscribers.length < 2; // true = 1 inscrito | false = mais de 1 inscrito
            return subscribers.map(subscriber => (
                !view ? {
                    evento: order.attributes.event?.data?.attributes?.name || '',
                    id: order.attributes.external_id || order.attributes.transaction,
                    uf: order.attributes.company?.data?.attributes?.state || '',
                    cidade: order.attributes.company?.data?.attributes?.city || '',
                    instituicao: order.attributes.company?.data?.attributes?.social_reason || '',
                    cpf: subscriber.attributes?.document || '',
                    nome: subscriber.attributes.isSubstitute ?
                        `${String(subscriber.attributes.name).toUpperCase()} (Substituto)`
                        : String(subscriber.attributes.name).toUpperCase() || '',
                    genero: subscriber.attributes?.gender || '',
                    email: subscriber.attributes?.email || '',
                    tamanho_camisa: subscriber.attributes?.tshirtSize || '',
                    hotel: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.name : 'Sem Hospedagem',
                    tipo: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.type : '',
                    quarto: subscriber.attributes?.hosting ? subscriber.attributes?.hosting.room : '',
                    entrada: order.attributes?.checkin ? format(parseISO(order.attributes?.checkin), 'dd/MM/yyyy') : '',
                    saida: order.attributes?.checkout ? format(parseISO(order.attributes?.checkout), 'dd/MM/yyyy') : '',
                    cnpj: order.attributes.company?.data?.attributes?.document || '',
                    pagamento: order.attributes.payment_form,
                    categoria: order.attributes.plan?.data?.attributes?.type || '',
                    total: order.attributes.total,
                    data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm'),
                    data_de_vencimento: order.attributes.bolecode?.data?.dado_boleto.dados_individuais_boleto[0]?.data_vencimento || '',
                    status: order.attributes.status == 'AGUARDANDO PAGAMENTO' ? 'NÃO PAGO' : order.attributes.status,
                } : {
                    evento: order.attributes.event?.data?.attributes?.name || '',
                    id: order.attributes.external_id || order.attributes.transaction,
                    uf: order.attributes.company?.data?.attributes?.state || '',
                    cidade: order.attributes.company?.data?.attributes?.city || '',
                    instituicao: order.attributes.company?.data?.attributes?.social_reason || '',
                    cpf: subscriber.attributes?.document || '',
                    nome: subscriber.attributes.isSubstitute ?
                        `${String(subscriber.attributes.name).toUpperCase()} (Substituto)`
                        : String(subscriber.attributes.name).toUpperCase() || '',
                    genero: subscriber.attributes?.gender || '',
                    email: subscriber.attributes?.email || '',
                    tamanho_camisa: subscriber.attributes?.tshirtSize || '',
                    hotel: order.attributes.hosting?.data?.attributes?.name ? order.attributes.hosting?.data?.attributes?.name : 'Sem Hospedagem',
                    tipo: order.attributes.hosting?.data?.attributes.type,
                    quarto: order.attributes.hosting?.data?.attributes?.room || '',
                    entrada: order.attributes?.checkin ? format(parseISO(order.attributes?.checkin), 'dd/MM/yyyy') : '',
                    saida: order.attributes?.checkout ? format(parseISO(order.attributes?.checkout), 'dd/MM/yyyy') : '',
                    cnpj: order.attributes.company?.data?.attributes?.document || '',
                    pagamento: order.attributes.payment_form,
                    categoria: order.attributes.plan?.data?.attributes?.type || '',
                    total: order.attributes.total,
                    data_de_inscricao: format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm'),
                    data_de_vencimento: order.attributes.bolecode?.data?.dado_boleto.dados_individuais_boleto[0]?.data_vencimento || '',
                    status: order.attributes.status == 'AGUARDANDO PAGAMENTO' ? 'NÃO PAGO' : order.attributes.status,
                }));
        });

        const sheet = XLSX.utils.json_to_sheet(sheetData);
        const dateCols = ['data_de_vencimento'];
        sheetData.forEach((row, rowIdx) => {
            dateCols.forEach((col) => {
                const colIdx = Object.keys(sheetData[0]).indexOf(col);
                const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 1, c: colIdx });
                if (sheet[cellRef] && row[col]) {
                    // Espera que row[col] esteja em formato 'dd/MM/yy' ou 'yyyy-MM-dd'
                    let dateObj;
                    if (row[col].includes('/')) {
                        // dd/MM/yy ou dd/MM/yyyy
                        let [day, month, year] = row[col].split('/');
                        if (year && year.length === 2) year = '20' + year; // converte para yyyy
                        dateObj = new Date(Number(year), Number(month) - 1, Number(day));
                    } else {
                        // yyyy-MM-dd
                        const [y, m, d] = row[col].split('-');
                        dateObj = new Date(Number(y), Number(m) - 1, Number(d));
                    }
                    sheet[cellRef].t = 'd';
                    sheet[cellRef].z = 'dd/mm/yyyy';
                    sheet[cellRef].v = dateObj;
                }
            });
        });
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, sheet, 'inscricoes');
        setRenderExcel(false);
        await XLSX.writeFile(workBook, `inscricoes-multiplos-eventos.xlsx`);
    };

    // Dados para o gráfico de pizza (boletos)
    const pieLabels = ['Pagos', 'Em Dia', 'Atrasados'];
    const pieColors = ['#43a047', '#1976d2', '#e53935'];
    const pieData = {
        labels: pieLabels,
        datasets: [
            {
                data: [
                    dashData.length > 0 ? dashData.filter(pay => pay.status === 'PAGO')[0]?.qt || 0 : 0,
                    dashData.length > 0 ? dashData.filter(pay => pay.status === 'AGUARDANDO PAGAMENTO')[0]?.qt || 0 : 0,
                    dashData.length > 0 ? dashData.filter(pay => pay.status === 'ATRASADA')[0]?.qt || 0 : 0,
                ],
                backgroundColor: pieColors,
                borderWidth: 2,
            },
        ],
    };
    // Gráfico de barras para Faturamento
    const faturamentoLabels = ['Previsto', 'Recebido'];
    const faturamentoColors = ['#FAD961', '#43a047'];
    const faturamentoData = {
        labels: faturamentoLabels,
        datasets: [
            {
                label: 'Faturamento',
                data: [
                    dashData.length > 0 ? dashData[0].ordersWait || 0 : 0,
                    dashData.length > 0 ? dashData[0].ordersPayed || 0 : 0,
                ],
                backgroundColor: faturamentoColors,
                borderRadius: 2,
                barPercentage: 0.5,
                categoryPercentage: 0.5,
            },
        ],
    };

    const statesData = dashData.find(d => d.states); // Busca o objeto correto
    const sortedStates = statesData && Array.isArray(statesData.states)
        ? [...statesData.states].sort((a, b) => b.total - a.total).slice(0, 5)
        : [];
    const barData = {
        labels: sortedStates.map(item => item.uf),      // Corrigido para acessar o campo uf
        datasets: [{
            label: 'Inscrições',
            data: sortedStates.map(item => item.total), // Corrigido para acessar o campo total
            backgroundColor: '#1976d2',
            borderRadius: 2,
        }],
    };
    const hostings = dashData[5]?.hostings || [];

    const groupedByHotel = hostings.reduce((acc, item) => {
        acc[item.name] = acc[item.name] || [];
        acc[item.name].push(item);
        return acc;
    }, {});

    const sortedAllStates = [...allStatesList].sort((a, b) => b.total - a.total);

    const allStatesBarData = {
        labels: sortedAllStates.map(item => `${item.uf} (${item.total})`),
        datasets: [{
            label: 'Inscrições',
            data: sortedAllStates.map(item => item.total),
            backgroundColor: '#1976d2',
            borderRadius: 4,
        }],
    };

    function handleOpenStatesDialog() {
        const statesData = dashData.find(d => d.states);
        setAllStatesList(statesData?.states || []);
        setOpenStatesDialog(true);
    };

    function toPayment() {
        navigation.setPage(`/financeiro/payment`)
        navigation.setLink(`/financeiro/payment`)
        navigate(`/financeiro/payment`)
    };

    async function deleteOrder() {
        const id = selectedOrder.id
        try {
            const orderDelete = await api.delete('/orders/' + id)
            if (orderDelete.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Inscrição deletada com sucesso` })
                setDeleteStatus(false)
                await handleSearch({ event: selectedEvent, status: selectedStatus, company: selectedCompany })
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.response.data.error.message || error.message}` })
        }
    };

    async function generateBolecode(order) {
        try {
            const id = order.id
            if (!id) {
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Selecione uma inscrição válida!` })
                return;
            }
            const response = await api.post('/order/bolecode', { data: { orderId: id } })
            if (response.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Boleto gerado com sucesso!` })
                await handleSearch({ event: selectedEvent, status: selectedStatus, company: selectedCompany })
            }
        } catch (error) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.response.data.error.message || error.message}` })
        }
    };

    async function updateOrder() {
        const id = selectedOrder.id
        try {
            const planSelected = listCategories.filter(plan => planUpdate == plan.id)
            const planEdit = planOrder.attributes.price;
            if (planSelected.length <= 0) {
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Selecione um plano válido!` })
                return;
            }
            if (planEdit > planSelected[0].attributes.price || planSelected[0].attributes.price > planEdit || planSelected[0].attributes.price > 0) {
                if (window.confirm('Atenção! Você está alterando o valor e o tipo de inscrição atual, isso irá gerar um novo boleto. Deseja continuar?')) {
                    // Atualiza o status para 'PENDENTE'
                    const newOrder = await api.put('/orders/' + id, { data: { status: 'PENDENTE', total: planSelected[0].attributes.price, payment_form: "Boleto", plan: planSelected[0].id } });
                    if (newOrder.status === 200) {
                        // Gera o novo boleto
                        await generateBolecode({ id });
                        await handleSearch({ event: selectedEvent, status: selectedStatus, company: selectedCompany, plan: planUpdate });
                        setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Inscrição atualizada e boleto gerado com sucesso!` });
                        setDialogOpen(false);
                    }
                }
                return;
            }
            const newOrder = await api.put('/orders/' + id, { data: { status: statusUpdate.trim() } })
            if (newOrder.status === 200) {
                await handleSearch({ event: selectedEvent, status: selectedStatus, company: selectedCompany, plan: planUpdate })
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Inscrição atualizada com sucesso!` })
                setDialogOpen(false)
            }
        } catch (error) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.response.data.error.message || error.message}` })
        }
    };

    async function handleEdit(order) {
        setSelectedOrder({ ...order });
        setStatusUpdate(order.attributes.status)
        listCategories.length === 0 && setListCategory([order.attributes.plan.data])
        if (selectedEvent) {
            setListCategory(eventOptions.filter(event => event.attributes.name === selectedEvent)[0]?.attributes.plans.data || [])
        }
        setPlanOrder(order.attributes.plan?.data || '');
        setNovoInscrito(null);
        setCpfNovoInscrito('');
        setPlanUpdate(order.attributes.plan?.data?.id || '');
        setSubscriberParaSubstituir(null);
        setEditOrder({
            company: {
                document: order.attributes.company?.data?.attributes?.document || '',
                social_reason: order.attributes.company?.data?.attributes?.social_reason || '',
                trade: order.attributes.company?.data?.attributes?.trade || '',
                address: order.attributes.company?.data?.attributes?.address || '',
                cep: order.attributes.company?.data?.attributes?.cep || '',
                city: order.attributes.company?.data?.attributes?.city || '',
                state: order.attributes.company?.data?.attributes?.state || '',
                email: order.attributes.company?.data?.attributes?.email || '',
                isDirty: false, // Adicionado para rastrear alterações
            },
            subscriber: order.attributes.subscribers?.data.map(subscriber => ({
                id: subscriber.id,
                document: subscriber.attributes.document || '',
                name: subscriber.attributes.name || '',
                birth: subscriber.attributes.birth || '',
                isSubstitute: subscriber.attributes.isSubstitute || '',
                email: subscriber.attributes.email || '',
                whatsapp: subscriber.attributes.whatsapp || '',
                badge: subscriber.attributes.badge || '',
                office: subscriber.attributes.office || '',
                gender: subscriber.attributes.gender || '',
                isDirty: false, // Adicionado para rastrear alterações
            })) || [],
            order: {
                external_id: order.attributes.external_id > 0 ? order.attributes.external_id : undefined,
                status: order.attributes.status || '',
                plan: order.attributes.plan?.data?.id || '',
                paymentDate: order.attributes.paymentDate || order.attributes.updatedAt,
                isDirty: false, // Adicionado para rastrear alterações

            },
        });

        setDialogOpen(true);
    };

    function handleDelete(order) {
        setSelectedOrder({ ...order })
        setDeleteStatus(true)
    };

    async function handlePayment(order) {
        if (order.attributes.payment_url !== null) {
            window.open(order.attributes.payment_url)
        }
    };

    async function loadCompany(company) {
        searchCompany.current = qs.stringify({
            filters: {
                social_reason: {
                    $containsi: company
                }
            },
            sort: ['social_reason:asc'],
            populate: '*',
            encodeValuesOnly: true,
        })
        try {
            const allCompanies = await api.get('/companies?' + searchCompany.current)
            setCompanies([...allCompanies.data.data])
            setLoadingCompany(false)
        } catch (error) {
            setLoadingCompany(false)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
        }
    };

    const inputCompanyDocument = e => {
        if (e.target.value.length > 18) { return }
        if (e.target.value.length > 0) { return setSelectedCompanyDocument(maskCNPJ(e.target.value)) }
        return setSelectedCompanyDocument(e.target.value)
    };

    async function loadCardsbyEvent() {
        setDataDash([])
        let dashQuery = {
            filters: {
                event: {
                    name: {
                        $contains: selectedEvent
                    },
                    deleted: false
                },
                deleted: false
            },
            populate: {
                event: {
                    fields: ['name']
                },
                plans: true
            },
            encodeValuesOnly: true
        }
        let query = qs.stringify(dashQuery, {
            skipNulls: true,
            skipUndefined: true,
            skipEmptyStrings: true
        })
        const dashData = await api.get(`/order/dashboard?${query}`)
        setDataDash(dashData.data)

    };

    async function handleUpdateOrder() {
        try {
            await editOrderValidationSchema.validate(editOrder, { abortEarly: false });

            // Atualiza a empresa e inscritos...
            if (editOrder.company?.isDirty) {
                const companyId = selectedOrder.attributes.company?.data?.id;
                if (companyId) {
                    await api.put(`/companies/${companyId}`, { data: editOrder.company });
                }
            }

            if (editOrder.subscriber && editOrder.subscriber.length > 0) {
                for (let i = 0; i < editOrder.subscriber.length; i++) {
                    const subscriber = editOrder.subscriber[i];
                    const subscriberId = selectedOrder.attributes.subscribers?.data[i]?.id;
                    if (subscriberId && subscriber.isDirty) {
                        await api.put(`/subscribers/${subscriberId}`, { data: subscriber });
                    }
                }
            }

            // Verifica alteração no plano
            if (editOrder.order?.isDirty) {
                const planSelected = listCategories.filter(plan => planUpdate == plan.id)[0];
                const planEdit = planOrder;

                if (!planSelected) {
                    setStateAlert({ status: true, type: 'error', msg: 'Selecione um plano válido!' });
                    return;
                }

                // Verifica se o plano realmente mudou
                const planChanged = planEdit.id !== planSelected.id;

                if (planChanged) {
                    // Se houver diferença de valor, mostra o modal de confirmação
                    if (planEdit.attributes.price !== planSelected.attributes.price && planSelected.attributes.price > 0) {
                        setPlanChangeData({
                            oldPlan: planEdit,
                            newPlan: planSelected,
                            orderId: selectedOrder.id
                        });
                        setConfirmBoletoDialog(true);
                        return;
                    } else if (planSelected.attributes.price == 0) {
                        setPlanChangeData({
                            oldPlan: planEdit,
                            newPlan: planSelected,
                            orderId: selectedOrder.id
                        });
                        setConfirmBoletoDialog(true);
                        return;
                    }

                    await updateOrderPlan(selectedOrder.id, editOrder);
                } else {
                    // Se o plano não mudou, mas outras informações do pedido foram alteradas
                    const statusOriginal = selectedOrder.attributes.status;
                    const statusNovo = editOrder.order.status;
                    
                    // Prepara os dados do pedido para atualização
                    let orderUpdateData = {
                        ...editOrder.order,
                        plan: editOrder.order.plan
                    };

                    // Se o status foi alterado para PAGO, registra a data de pagamento
                    if (statusNovo === 'PAGO' && statusOriginal !== 'PAGO') {
                        orderUpdateData.payment_date = new Date().toISOString();
                    }

                    // Atualiza o pedido com as informações modificadas
                    await api.put(`/orders/${selectedOrder.id}`, {
                        data: orderUpdateData
                    });
                }
            }

            setStateAlert({
                status: true,
                type: 'success',
                msg: 'Dados atualizados com sucesso!'
            });
            setDialogOpen(false);
            await handleSearch();

        } catch (error) {
            handleError(error);
        }
    };

    async function updateOrderPlan(orderId, orderData) {
        let orderPlan = listCategories.filter(plan => plan.id == orderData.order.plan)[0];
        if (orderPlan.attributes.price > 0 && orderPlan.attributes.price != orderData.order.total) {
            // Atualiza o status para 'PENDENTE'
            const newOrder = await api.put('/orders/' + orderId, {
                data:
                {
                    ...orderData.order,
                    status: 'PENDENTE',
                    payment_form: "Boleto",
                    total: orderPlan.attributes.price,
                    plan: orderData.order.plan
                }
            });
            if (newOrder.status == 200) {
                await generateBolecode({ id: orderId });
            }
        } else if (orderPlan.attributes.price == 0) {
            // Plano gratuito, mantém como 'PAGO'
            await api.put('/orders/' + orderId, {
                data:
                {
                    ...orderData.order,
                    payment_form: "Gratuito",
                    total: 0,
                    plan: orderData.order.plan
                }
            });
        }

    };

    function handleError(error) {
        if (error.name === 'ValidationError') {
            const validationErrors = error.inner.map(err => err.message).join(', ');
            setStateAlert({
                status: true,
                type: 'error',
                msg: `Erro de validação: ${validationErrors}`
            });
        } else {
            setStateAlert({
                status: true,
                type: 'error',
                msg: error.response?.data?.error?.message || error.message
            });
        }
    };

    async function buscarNovoInscritoPorCPF() {
        setBuscandoNovoInscrito(true);
        setNovoInscrito(null);
        try {
            const res = await api.post('/subscriber/form', { data: { cpf: cpfNovoInscrito } });
            if (res.data && res.data) {
                setNovoInscrito(res.data);
            } else {
                setStateAlert({ status: true, type: 'error', msg: 'Inscrito não encontrado!' });
            }
        } catch (err) {
            setStateAlert({ status: true, type: 'error', msg: 'Inscrito não encontrado!' });
        }
        setBuscandoNovoInscrito(false);
    };

    async function adicionarInscritoSubstitutoCPF() {
        if (!novoInscrito || !selectedOrder) return;
        const orderId = selectedOrder.id;
        let substituidoId = null;
        if (editOrder.subscriber && editOrder.subscriber.length > 1 && subscriberParaSubstituir !== null) {
            substituidoId = selectedOrder.attributes.subscribers?.data[subscriberParaSubstituir]?.id;
        } else if (editOrder.subscriber && editOrder.subscriber.length === 1) {
            substituidoId = selectedOrder.attributes.subscribers?.data[0]?.id;
        }
        // 1. Cria um novo subscriber com os dados do novoInscrito
        const res = await api.post('/subscribers', {
            data: {
                document: cpfNovoInscrito,
                name: novoInscrito.name,
                birth: novoInscrito.birth,
                email: novoInscrito.email,
                whatsapp: novoInscrito.whatsapp,
                badge: novoInscrito.badge,
                office: novoInscrito.office,
                gender: novoInscrito.gender,
                isSubstitute: substituidoId ? String(substituidoId) : '',
                event: selectedOrder.attributes.event?.data?.id,
                company: selectedOrder.attributes.company?.data?.id
            }
        });
        const novoSubscriberId = res.data.data.id;
        alert(novoSubscriberId)
        // 2. Associa TODOS os subscribers (antigos + novo) à order
        const currentSubscribers = selectedOrder.attributes.subscribers?.data?.map(sub => sub.id) || [];
        const allSubscribers = [...currentSubscribers, novoSubscriberId];
        const uniqueSubscribers = Array.from(new Set(allSubscribers));
        // 3. Associa o novo subscriber à order (mantendo os antigos)
        await api.put(`/orders/${orderId}`, {
            data: {
                subscribers: uniqueSubscribers
            }
        });

        setStateAlert({
            status: true,
            type: 'success',
            msg: 'Inscrito substituto adicionado com sucesso!'
        });
        setDialogOpen(false);
        setNovoInscrito(null);
        setCpfNovoInscrito('');
        setSubscriberParaSubstituir(null);
        await handleSearch();
    };

    useEffect(() => {
        if (events.length === 0) {
            loadInitialEvents();
        };
        if (selectedEvent && selectedEvent?.length > 0) {
            loadCardsbyEvent();
            setSelectedCategory("");
            events.map(evento => {
                if (evento.attributes.name == selectedEvent) {
                    return setListCategory(evento.attributes.plans.data)
                }
            })
        } else {
            setSelectedCategory("");
            setListCategory([]);
            setDataDash([]);
        }
    }, [selectedEvent])

    useEffect(() => {
        if (events && events.length > 0) {
            const newEvents = events.filter(event => !eventIdsRef.current.has(event.id));
            if (newEvents.length > 0) {
                newEvents.forEach(event => eventIdsRef.current.add(event.id));
                setEventOptions(prev => {
                    const existingIds = new Set(prev.map(e => e.id));
                    const filtered = newEvents.filter(e => !existingIds.has(e.id));
                    return [...prev, ...filtered];
                });
            }
        }
    }, [events])


    return (
        <Box sx={{ width: '100%', height: '100vh' }} p={3}>
            <Snackbar
                open={stateAlert.status}
                autoHideDuration={2500}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={() => setStateAlert({ status: false, type: 'success', msg: '' })} >
                <Alert sx={{ width: '100%' }} severity={`${stateAlert.type}`}>
                    {stateAlert.msg}
                </Alert>
            </Snackbar>
            <Stack direction="column" alignItems="flex-start" justifyContent={'flex-start'} spacing={2} mx={4}>
                <Typography variant='h4'>Pedidos de inscrição</Typography>
                <Grid container direction='row' spacing={2} width={'100%'} py={3}>
                    <Grid item xs={12} sm={dashData[5]?.hostings.length > 0 ? 3 : 4}>
                        <Card sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: 340, backgroundColor: '#F3F3F3' }}>
                            <CardContent sx={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                <Box py={1} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                                    <Box px={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, borderRadius: 50, backgroundColor: '#0093E9', backgroundImage: 'linear-gradient(45deg, #0093E9 0%, #80D0C7 100%)' }}>
                                        <RequestQuoteIcon />
                                    </Box>
                                    <Typography py={1} px={2} sx={{ fontSize: 18, fontWeight: 400 }} component="div">
                                        Cobranças
                                    </Typography>
                                </Box>
                                {selectedEvent && dashData.length > 0 && (
                                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
                                        <Box sx={{ width: 350, height: 240 }}>
                                            <Pie
                                                data={pieData}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: false,
                                                    plugins: {
                                                        legend: { position: 'bottom' },
                                                        tooltip: { callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}` } }
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={dashData[5]?.hostings.length > 0 ? 3 : 4}>
                        <Card sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: 340, backgroundColor: '#F3F3F3' }}>
                            <CardContent sx={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                <Box py={1} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                                    <Box px={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, borderRadius: 50, backgroundColor: '#FAD961', backgroundImage: 'linear-gradient(45deg, #FAD961 0%, #F76B1C 100%)' }}>
                                        <EqualizerIcon />
                                    </Box>
                                    <Typography py={1} px={2} sx={{ fontSize: 18, fontWeight: 400 }}>
                                        Faturamento
                                    </Typography>
                                </Box>
                                {selectedEvent && dashData.length > 0 && (
                                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
                                        <Box sx={{ width: 350, height: 240 }}>
                                            <Bar
                                                data={faturamentoData}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: false,
                                                    plugins: {
                                                        legend: { display: false },
                                                        tooltip: {
                                                            callbacks: {
                                                                label: ctx => `R$ ${Number(ctx.parsed.y).toLocaleString('pt-br', { minimumFractionDigits: 2 })}`
                                                            }
                                                        }
                                                    },
                                                    scales: {
                                                        y: {
                                                            beginAtZero: true,
                                                            ticks: {
                                                                callback: value => `R$ ${Number(value).toLocaleString('pt-br', { minimumFractionDigits: 2 })}`
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={dashData[5]?.hostings.length > 0 ? 3 : 4}>
                        <Card sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: 340, backgroundColor: '#F3F3F3' }}>
                            <CardContent sx={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                <Box py={1} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                                    <Box px={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, borderRadius: 50, backgroundColor: '#1976d2', backgroundImage: 'linear-gradient(45deg, #1976d2 0%, #43a047 100%)' }}>
                                        <Analytics />
                                    </Box>
                                    <Typography py={1} px={2} sx={{ fontSize: 18, fontWeight: 400 }}>
                                        Inscrições por Estado
                                    </Typography>
                                </Box>
                                {selectedEvent && Object.keys(barData).length > 0 && (
                                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
                                        <Box sx={{ width: 350, height: 240 }} onClick={handleOpenStatesDialog}>
                                            <Bar
                                                data={barData}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: false,
                                                    plugins: {
                                                        legend: { display: false },
                                                        tooltip: {
                                                            callbacks: {
                                                                label: ctx => `Inscrições: ${ctx.parsed.y}`
                                                            }
                                                        }
                                                    },
                                                    scales: {
                                                        y: {
                                                            beginAtZero: true,
                                                            ticks: {
                                                                precision: 0
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                    {dashData && dashData[5]?.hostings.length > 0 &&
                        <Grid item xs={12} sm={dashData[5]?.hostings.length > 0 ? 3 : 4}>
                            <Card sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: 340, backgroundColor: '#F3F3F3' }}>
                                <CardContent sx={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                    <Box py={1} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                                        <Box px={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, borderRadius: 50, backgroundColor: '#1976d2', backgroundImage: 'linear-gradient(45deg, #a419d2ff 0%, #ab6cdcff 100%)' }}>
                                            <Hotel />
                                        </Box>
                                        <Typography py={1} px={2} sx={{ fontSize: 18, fontWeight: 400 }}>
                                            Hospedagens
                                        </Typography>
                                    </Box>
                                    {selectedEvent && hostings.length > 0 && (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                mt: 2
                                            }}
                                        >
                                            <Box sx={{ width: 370, height: 220 }}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell><strong>Hotel</strong></TableCell>
                                                            <TableCell><strong>Tipo</strong></TableCell>
                                                            <TableCell align="right"><strong>Pessoas</strong></TableCell>
                                                            <TableCell align="right"><strong>Quartos</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {hostings.map((row, idx) => (
                                                            <TableRow key={idx}>
                                                                <TableCell>{row.name}</TableCell>
                                                                <TableCell>{row.type}</TableCell>
                                                                <TableCell align="right">{row.total_pessoas}</TableCell>
                                                                <TableCell align="right">{row.total_quartos}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                        </Box>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                </Grid>

                <Grid container direction='row' spacing={2} width={'100%'} py={1}>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                id="select-event-infinite-scroll"
                                options={eventOptions}
                                loading={loadingEvents}
                                getOptionLabel={(option) => option.attributes?.name || ''}
                                value={eventOptions.find(e => e.attributes?.name === selectedEvent) || null}
                                onChange={(_, newValue) => {
                                    page.current = 1;
                                    setSelectedEvent(newValue?.attributes?.name || '');
                                    setSelectedCategory("");
                                    setSelectedCompany(null);
                                    setSelectedCompanyDocument(null);
                                    setSelectedStatus("");
                                    document.getElementById('asynchronous-companies').value = '';
                                }}
                                onInputChange={(_, value, reason) => {
                                    if (reason === 'input') {
                                        setEventSearchText(value);
                                        clearTimeout(eventSearchTimer.current);
                                        eventSearchTimer.current = setTimeout(() => {
                                            searchEventsByText(value);
                                        }, 800);
                                    }
                                }}
                                filterOptions={(options) => options}
                                ListboxProps={{
                                    ref: listboxRef,
                                    onScroll: (event) => {
                                        const listbox = event.currentTarget;
                                        scrollPositionRef.current = listbox.scrollTop;
                                        
                                        // Carrega mais apenas se não estiver buscando por texto
                                        if (
                                            listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 10 &&
                                            hasMoreEvents &&
                                            !loadingEvents &&
                                            (!eventSearchText || eventSearchText.trim().length < 2)
                                        ) {
                                            loadMoreEvents();
                                        }
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Selecionar Evento"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loadingEvents ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth >
                            <InputLabel>Selecionar Status:</InputLabel>
                            <Select
                                id="select-status"
                                value={selectedStatus || ""}
                                onChange={(event) => {
                                    setSelectedStatus(event.target.value);
                                }}
                                label="Selecionar Status"
                            >
                                <MenuItem value="">
                                    <em>Nenhum</em>
                                </MenuItem>
                                {status.map((status, index) =>
                                    <MenuItem key={index} value={status}>{status}</MenuItem>
                                )
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth >
                            <InputLabel id="select-category">Selecionar Categoria:</InputLabel>
                            <Select
                                labelId="select-category"
                                id="select-category"
                                value={selectedCategory || ""}
                                onChange={(event) => {
                                    setSelectedCategory(event.target.value);
                                }
                                }
                                label="Selecionar Categoria"
                            >
                                <MenuItem value="">
                                    <em>Nenhum</em>
                                </MenuItem>
                                {listCategories.length > 0 && listCategories.map(plan =>
                                    <MenuItem key={plan.id} value={plan.attributes.type}>{plan.attributes.type}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                id="asynchronous-companies"
                                sx={{ width: "100%" }}
                                open={search}
                                onOpen={() => setSearch(true)}
                                onClose={() => setSearch(false)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                getOptionLabel={(option) => option?.attributes?.social_reason || ""}
                                value={selectedCompany ? companies.find(company => company.attributes.social_reason === selectedCompany) : null}
                                options={companies}
                                onChange={(event, value) => {
                                    if (value) {
                                        setSelectedCompany(value.attributes.social_reason)
                                    } else {
                                        setSelectedCompany(null)
                                        document.getElementById('asynchronous-companies').value = ''
                                    }
                                }}
                                loading={loadingCompany}
                                onInputChange={(event, value) => {
                                    clearTimeout(timer);
                                    if (!value) return;
                                    const newTimer = setTimeout(() => loadCompany(value), 500);
                                    setTimer(newTimer);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Selecionar Instituição"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loadingCompany ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <TextField
                                label="Pesquisar CNPJ:"
                                variant="outlined"
                                labelId="select-document"
                                value={selectedCompanyDocument || ""}
                                onChange={inputCompanyDocument}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <TextField
                                label="Pesquisar por N° Inscrição:"
                                variant="outlined"
                                labelId="select-external_id"
                                value={selectedExternal || ""}
                                onChange={(event) => {
                                    setSelectedExternal(event.target.value);
                                }
                                }
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <TextField
                                label="Pesquisar Nome do  Inscrito"
                                variant="outlined"
                                value={selectedSubscriberName || ""}
                                onChange={(event) => setSelectedSubscriberName(event.target.value)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <InputLabel id="select-hospedagem">Hospedagem</InputLabel>
                            <Select
                                labelId="select-hospedagem"
                                id="select-hospedagem"
                                value={selectedHospedagem}
                                label="Hospedagem"
                                defaultValue='all'
                                onChange={e => setSelectedHospedagem(e.target.value)}
                            >
                                <MenuItem value="all">Todos</MenuItem>
                                <MenuItem value="nohosting">Sem Hospedagem</MenuItem>
                                <MenuItem value="hosting">Com Hospedagem</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Stack direction='row' spacing={8} width={"100%"} alignItems={"flex-end"} justifyContent={'flex-end'}>
                    <Button sx={{ width: "20%" }} variant='contained' color='info' onClick={() => handleSearch({ event: selectedEvent, status: selectedStatus, company: selectedCompany, document: selectedCompanyDocument, category: selectedCategory })}>Pesquisar</Button>
                    <Button sx={{ width: "20%" }} variant='contained' color='success' onClick={() => handleExcel()} disabled={renderExcel}>
                        {renderExcel ? <CircularProgress sx={{ alignSelf: 'center' }} size={20} /> : "Exportar para Excel"}
                    </Button>
                    <Button sx={{ width: "20%" }} variant='contained' color='secondary' onClick={() => setOpenExportDialog(true)}>
                        Exportar eventos selecionados
                    </Button>
                    <Button sx={{ width: "20%" }} variant='contained' color='warning' onClick={toPayment}>Gerar cobrança</Button>
                </Stack>
            </Stack>
            {
                loading ?
                    <Box sx={{ width: '100%', height: '10vh', display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress sx={{ alignSelf: 'center' }} size={50} />
                    </Box>
                    :
                    <>
                        <Grid container py={3} width={"100%"}>
                            <TableCollapsible title='Inscrições' variant="secondary" edit={handleEdit} deactive={handleDelete} payment={handlePayment} generateBolecode={generateBolecode} rows={orders} columns={columnsOrders} />
                        </Grid>
                        <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2} mx={10}>
                            <Pagination count={pagination.pageCount} defaultPage={1} color="primary" page={page.current}
                                onChange={(event, value) => {
                                    page.current = value
                                    handleSearch()
                                }} />
                        </Stack>
                    </>
            }

            <Dialog
                open={dialogOpen}
                aria-describedby="edit-dialog"
                fullScreen
                maxWidth='xl'>
                <DialogTitle>{"Editar Inscrição"}</DialogTitle>
                <DialogContent sx={{ width: '100%', height: '100%' }}>
                    {basePath == 'agip' &&
                        <Grid container spacing={6} py={2} >
                            <Grid item sm={12}>
                                <TextField sx={{ width: '100%' }}
                                    label="Inscrição"
                                    id='transaction'
                                    name="transaction"
                                    disabled
                                    variant="outlined"
                                    value={selectedOrder ? selectedOrder.attributes.transaction : ''}
                                    placeholder="Inscrição" />
                            </Grid>
                            <Grid item sm={12}>
                                <TextField sx={{ width: '100%' }}
                                    label="Instituição"
                                    id='company'
                                    name="company"
                                    disabled
                                    value={selectedOrder ? selectedOrder.attributes.company.data.attributes.social_reason.toUpperCase() : ''}
                                    variant="outlined"
                                    placeholder="Instituição" />
                            </Grid>
                            <Grid item sm={12}>
                                <TextField sx={{ width: '100%' }}
                                    label="Nome Fantasia"
                                    id='trade'
                                    name="trade"
                                    disabled
                                    value={selectedOrder ? selectedOrder.attributes.company.data.attributes.trade.toUpperCase() : ''}
                                    variant="outlined"
                                    placeholder="Nome Fantasia" />
                            </Grid>
                            <Grid item sm={12}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="selected-status">Alterar Status:</InputLabel>
                                    <Select
                                        labelId="selected-status"
                                        id="selected-status"
                                        disabled={(selectedOrder && ((basePath == 'agip' && selectedOrder.attributes.payment_form == 'Boleto') || selectedOrder.attributes.status == 'PAGO' || selectedOrder.attributes.status == 'REEMBOLSADA'))}
                                        onChange={(event) => setStatusUpdate(event.target.value)}
                                        value={statusUpdate || (selectedOrder && selectedOrder.attributes.status)}
                                        label="Alterar Status"
                                    >
                                        {status.map((status, index) =>
                                            <MenuItem key={index} value={status}>{status}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>}
                    {basePath == 'apeprev' &&
                        <>
                            <Typography>Instituição:</Typography>
                            <Grid container spacing={2} py={2} fullWidth sx={{ width: '100%' }} >
                                <Grid item sm={2}>
                                    <TextField sx={{ width: '100%' }}
                                        label="CNPJ:"
                                        id='document'
                                        name="document"
                                        disabled
                                        value={selectedOrder ? selectedOrder.attributes?.company?.data?.attributes?.document : ''}
                                        variant="outlined"
                                        placeholder="CNPJ:" />
                                </Grid>
                                <Grid item sm={8}>
                                    <TextField
                                        sx={{ width: '100%' }}
                                        label="Instituição"
                                        id="company"
                                        name="company"
                                        value={editOrder.company?.social_reason || ''}
                                        onChange={(e) =>
                                            setEditOrder({
                                                ...editOrder,
                                                company: {
                                                    ...editOrder.company,
                                                    social_reason: e.target.value,
                                                    isDirty: true,
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        placeholder="Instituição"
                                    />
                                </Grid>
                                <Grid item sm={2}>
                                    <TextField
                                        sx={{ width: '100%' }}
                                        label="Nome Fantasia"
                                        id="trade"
                                        name="trade"
                                        value={editOrder.company?.trade || ''}
                                        onChange={(e) =>
                                            setEditOrder({
                                                ...editOrder,
                                                company: {
                                                    ...editOrder.company,
                                                    trade: e.target.value,
                                                    isDirty: true,
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        placeholder="Nome Fantasia"
                                    />
                                </Grid>
                                <Grid item sm={4}>
                                    <TextField
                                        sx={{ width: '100%' }}
                                        label="Endereço:"
                                        id="address"
                                        name="address"
                                        value={editOrder.company?.address || ''}
                                        onChange={(e) =>
                                            setEditOrder({
                                                ...editOrder,
                                                company: {
                                                    ...editOrder.company,
                                                    address: e.target.value,
                                                    isDirty: true,
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        placeholder="Endereço:"
                                    />
                                </Grid>
                                <Grid item sm={2}>
                                    <TextField
                                        sx={{ width: '100%' }}
                                        label="CEP:"
                                        id="cep"
                                        name="cep"
                                        value={editOrder.company?.cep || ''}
                                        onChange={(e) =>
                                            setEditOrder({
                                                ...editOrder,
                                                company: {
                                                    ...editOrder.company,
                                                    cep: e.target.value,
                                                    isDirty: true,
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        placeholder="CEP:"
                                    />
                                </Grid>
                                <Grid item sm={2}>
                                    <TextField
                                        sx={{ width: '100%' }}
                                        label="Cidade:"
                                        id="city"
                                        name="city"
                                        value={editOrder.company?.city || ''}
                                        onChange={(e) =>
                                            setEditOrder({
                                                ...editOrder,
                                                company: {
                                                    ...editOrder.company,
                                                    city: e.target.value,
                                                    isDirty: true,
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        placeholder="Cidade:"
                                    />
                                </Grid>
                                <Grid item sm={2}>
                                    <TextField
                                        sx={{ width: '100%' }}
                                        label="Estado:"
                                        id="uf"
                                        name="uf"
                                        value={editOrder.company?.state || ''}
                                        onChange={(e) =>
                                            setEditOrder({
                                                ...editOrder,
                                                company: {
                                                    ...editOrder.company,
                                                    state: e.target.value,
                                                    isDirty: true,
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        placeholder="Estado:"
                                    />
                                </Grid>
                                <Grid item sm={2}>
                                    <TextField
                                        sx={{ width: '100%' }}
                                        label="Email:"
                                        id="email"
                                        name="email"
                                        value={editOrder.company?.email || ''}
                                        onChange={(e) =>
                                            setEditOrder({
                                                ...editOrder,
                                                company: {
                                                    ...editOrder.company,
                                                    email: e.target.value,
                                                    isDirty: true,
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        placeholder="Email:"
                                    />
                                </Grid>
                                <Grid item sm={12} />
                                {editOrder.subscriber && editOrder.subscriber.map((subscriber, index) => {
                                    return (
                                        <>
                                            <Typography mx={1}>Inscrito:</Typography>
                                            <Grid container mx={1} spacing={0.5} py={1} key={subscriber.id}>
                                                {subscriber.isSubstitute && (
                                                    <Grid item sm={12} p={4}>
                                                        <Alert severity="warning" sx={{ width: '100%' }}>
                                                            Inscrito é um substituto de &nbsp;
                                                            {(() => {
                                                                const original = selectedOrder?.attributes?.subscribers?.data?.find(sub =>
                                                                    String(sub.id) === subscriber.isSubstitute
                                                                );
                                                                return original
                                                                    ? `${original.attributes.name} (ID: ${original.id})`
                                                                    : `ID: ${subscriber.isSubstitute}`;
                                                            })()}
                                                        </Alert>
                                                    </Grid>
                                                )}
                                                <Grid item sm={2}>
                                                    <TextField sx={{ width: '100%' }}
                                                        label="CPF:"
                                                        id={`subscriber-document-${index}`}
                                                        name="document"
                                                        value={editOrder.subscriber?.[index]?.document || ''}
                                                        onChange={(e) => {
                                                            const updatedSubscribers = [...(editOrder.subscriber || [])];
                                                            updatedSubscribers[index] = {
                                                                ...updatedSubscribers[index],
                                                                document: maskCPF2(e.target.value),
                                                                isDirty: true,
                                                            };
                                                            setEditOrder({
                                                                ...editOrder,
                                                                subscriber: updatedSubscribers,
                                                            });
                                                        }}
                                                        variant="outlined"
                                                        placeholder="CPF:" />
                                                </Grid>
                                                <Grid item sm={2}>
                                                    <TextField sx={{ width: '100%' }}
                                                        label="Nome:"
                                                        id={`subscriber-name-${index}`}
                                                        name="name"
                                                        value={editOrder.subscriber?.[index]?.name || ''}
                                                        onChange={(e) => {
                                                            const updatedSubscribers = [...(editOrder.subscriber || [])];
                                                            updatedSubscribers[index] = {
                                                                ...updatedSubscribers[index],
                                                                name: e.target.value,
                                                                isDirty: true,
                                                            };
                                                            setEditOrder({
                                                                ...editOrder,
                                                                subscriber: updatedSubscribers,
                                                            });
                                                        }}
                                                        variant="outlined"
                                                        placeholder="Nome:" />
                                                </Grid>
                                                <Grid item sm={1}>
                                                    <TextField sx={{ width: '100%' }}
                                                        label="Data de Nascimento:"
                                                        type='date'
                                                        id={`subscriber-birth-${index}`}
                                                        name="birth"
                                                        value={editOrder.subscriber?.[index]?.birth || ''}
                                                        onChange={(e) => {
                                                            const updatedSubscribers = [...(editOrder.subscriber || [])];
                                                            updatedSubscribers[index] = {
                                                                ...updatedSubscribers[index],
                                                                birth: e.target.value,
                                                                isDirty: true,
                                                            };
                                                            setEditOrder({
                                                                ...editOrder,
                                                                subscriber: updatedSubscribers
                                                            });
                                                        }}
                                                        variant="outlined"
                                                        placeholder="Data de Nascimento:" />
                                                </Grid>
                                                <Grid item sm={1}>
                                                    <TextField sx={{ width: '100%' }}
                                                        label="Gênero"
                                                        type='text'
                                                        id={`subscriber-gender-${index}`}
                                                        name="gender"
                                                        value={editOrder.subscriber?.[index]?.gender || ''}
                                                        helperText="M, F ou Outro"
                                                        onChange={(e) => {
                                                            const updatedSubscribers = [...(editOrder.subscriber || [])];
                                                            updatedSubscribers[index] = {
                                                                ...updatedSubscribers[index],
                                                                gender: e.target.value,
                                                                isDirty: true,
                                                            };
                                                            setEditOrder({
                                                                ...editOrder,
                                                                subscriber: updatedSubscribers
                                                            });
                                                        }}
                                                        variant="outlined"
                                                        placeholder="Gênero " />
                                                </Grid>
                                                <Grid item sm={1}>
                                                    <TextField sx={{ width: '100%' }}
                                                        label="Crachá:"
                                                        id={`subscriber-badge-${index}`}
                                                        name="badge"
                                                        value={editOrder.subscriber?.[index]?.badge || ''}
                                                        onChange={(e) => {
                                                            const updatedSubscribers = [...(editOrder.subscriber || [])];
                                                            updatedSubscribers[index] = {
                                                                ...updatedSubscribers[index],
                                                                badge: e.target.value,
                                                                isDirty: true,
                                                            };
                                                            setEditOrder({
                                                                ...editOrder,
                                                                subscriber: updatedSubscribers
                                                            });
                                                        }}
                                                        variant="outlined"
                                                        placeholder="Badge:" />
                                                </Grid>
                                                <Grid item sm={2}>
                                                    <TextField sx={{ width: '100%' }}
                                                        label="Email:"
                                                        id={`subscriber-email-${index}`}
                                                        name="email"
                                                        value={editOrder.subscriber?.[index]?.email || ''}
                                                        onChange={(e) => {
                                                            const updatedSubscribers = [...(editOrder.subscriber || [])];
                                                            updatedSubscribers[index] = {
                                                                ...updatedSubscribers[index],
                                                                email: e.target.value,
                                                                isDirty: true,
                                                            };
                                                            setEditOrder({
                                                                ...editOrder,
                                                                subscriber: updatedSubscribers,
                                                            });
                                                        }}
                                                        variant="outlined"
                                                        placeholder="Email:" />
                                                </Grid>
                                                <Grid item sm={1}>
                                                    <TextField sx={{ width: '100%' }}
                                                        label="WhatsApp:"
                                                        id={`subscriber-whatsapp-${index}`}
                                                        name="whatsapp"
                                                        value={editOrder.subscriber?.[index]?.whatsapp || ''}
                                                        onChange={(e) => {
                                                            const updatedSubscribers = [...(editOrder.subscriber || [])];
                                                            updatedSubscribers[index] = {
                                                                ...updatedSubscribers[index],
                                                                whatsapp: e.target.value,
                                                                isDirty: true,
                                                            };
                                                            setEditOrder({
                                                                ...editOrder,
                                                                subscriber: updatedSubscribers
                                                            });
                                                        }}
                                                        variant="outlined"
                                                        placeholder="WhatsApp:" />
                                                </Grid>
                                                <Grid item sm={1.5}>
                                                    <TextField sx={{ width: '100%' }}
                                                        label="Cargo:"
                                                        id={`subscriber-office-${index}`}
                                                        name="office"
                                                        value={editOrder.subscriber?.[index]?.office || ''}
                                                        onChange={(e) => {
                                                            const updatedSubscribers = [...(editOrder.subscriber || [])];
                                                            updatedSubscribers[index] = {
                                                                ...updatedSubscribers[index],
                                                                office: e.target.value,
                                                                isDirty: true,
                                                            };
                                                            setEditOrder({
                                                                ...editOrder,
                                                                subscriber: updatedSubscribers
                                                            });
                                                        }}
                                                        variant="outlined"
                                                        placeholder="Cargo:" />
                                                </Grid>
                                                {subscriber.isSubstitute && (
                                                    <Grid item sm={0.5}>
                                                        <Button
                                                            variant="outlined"
                                                            color="error"
                                                            size="small"
                                                            sx={{ ml: 2, minWidth: 80, minHeight: '70%' }}
                                                            onClick={async () => {
                                                                // Remove o inscrito substituto do editOrder
                                                                const updatedSubscribers = editOrder.subscriber.filter((_, i) => i !== index);
                                                                setEditOrder({
                                                                    ...editOrder,
                                                                    subscriber: updatedSubscribers
                                                                });
                                                                // Opcional: faça a exclusão no backend, se necessário
                                                                const subscriberId = subscriber.id;
                                                                if (subscriberId) {
                                                                    try {
                                                                        await api.delete(`/subscribers/${subscriberId}`);
                                                                        setStateAlert({ status: true, type: 'success', msg: 'Substituto excluído com sucesso!' });
                                                                        await handleSearch();
                                                                    } catch (err) {
                                                                        setStateAlert({ status: true, type: 'error', msg: 'Erro ao excluir substituto!' });
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            Excluir
                                                        </Button>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </>
                                    )
                                })}
                                <Grid item sm={12} />
                                <Typography mx={1}>Pedido:</Typography>
                                <Grid item sm={2}>
                                    <TextField sx={{ width: '100%' }}
                                        label="Número de Inscrição"
                                        id='transaction'
                                        name="transaction"
                                        disabled
                                        variant="outlined"
                                        value={selectedOrder ? selectedOrder.attributes.external_id : ''}
                                        placeholder="Número de Inscrição" />
                                </Grid>
                                <Grid item sm={3}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel id="selected-status">Alterar Status:</InputLabel>
                                        <Select
                                            labelId="selected-status"
                                            id="selected-status"
                                            disabled={(selectedOrder && (((basePath == 'agip' && selectedOrder.attributes.payment_form == 'Boleto') && selectedOrder.attributes.status == 'PAGO') || selectedOrder.attributes.status == 'REEMBOLSADA'))}
                                            onChange={(event) => {
                                                setEditOrder({
                                                    ...editOrder,
                                                    order: {
                                                        ...editOrder.order,
                                                        status: event.target.value,
                                                        isDirty: true,
                                                    },
                                                });
                                                setStatusUpdate(event.target.value)
                                            }}
                                            value={statusUpdate || (selectedOrder && selectedOrder.attributes.status)}
                                            label="Alterar Status"
                                        >
                                            {status.map((status, index) =>
                                                <MenuItem key={index} value={status}>{status}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid >
                                <Grid item sm={2}>
                                    {editOrder &&
                                        <TextField sx={{ width: '100%' }}
                                            label="Data de Pagamento:"
                                            type='date'
                                            value={editOrder && editOrder?.order?.status === 'PAGO' && editOrder?.order?.paymentDate ? format(parseISO(editOrder.order.paymentDate), 'yyyy-MM-dd') : ''}
                                            focused
                                            disabled={editOrder && editOrder?.order?.status !== 'PAGO'}
                                            id='paymentDate'
                                            onChange={(e) => {
                                                setEditOrder({
                                                    ...editOrder,
                                                    order: {
                                                        ...editOrder.order,
                                                        paymentDate: e.target.value,
                                                        isDirty: true,
                                                    },
                                                });
                                            }}
                                            variant="outlined"
                                            placeholder="Data de Pagamento:" />
                                    }
                                </Grid>
                                <Grid item sm={3}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel id="selected-plan-attributes">Alterar Tipo de inscrição:</InputLabel>
                                        <Select
                                            error={listCategories.length === 0 && !selectedEvent}
                                            helperText={listCategories.length === 0 && !selectedEvent ? 'Selecione um evento para ver as categorias disponíveis.' : ''}
                                            labelId="selected-plan-attributes"
                                            id="selected-plan-attributes"
                                            disabled={selectedOrder && (selectedOrder.attributes.status == 'REEMBOLSADA' || selectedOrder.attributes.status == 'CANCELADA')}
                                            onChange={(event) => {
                                                setEditOrder({
                                                    ...editOrder,
                                                    order: {
                                                        ...editOrder.order,
                                                        plan: event.target.value,
                                                        isDirty: true,
                                                    },
                                                });
                                                setPlanUpdate(event.target.value)
                                            }}
                                            value={planUpdate}
                                            label="Alterar Tipo de inscrição"
                                        >
                                            {listCategories.map((plan, index) => {
                                                if (plan.id == planUpdate) return (<MenuItem key={index} selected value={plan.id}>{plan.attributes.type}</MenuItem>)
                                                return (<MenuItem key={index} value={plan.id}>{plan.attributes.type}</MenuItem>)
                                            }
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </>
                    }
                    <Grid item sm={12}>
                        {editOrder.subscriber && (() => {
                            // Se só existe 1 inscrito, ele é elegível para substituição
                            let elegiveis = [];
                            if (editOrder.subscriber.length === 1) {
                                // Só não permite se ele já for substituto
                                if (!editOrder.subscriber[0].isSubstitute) {
                                    elegiveis = [editOrder.subscriber[0]];
                                }
                            } else {
                                // Se mais de 1, aplica a regra normal
                                elegiveis = editOrder.subscriber.filter(sub => {
                                    if (sub.isSubstitute) return false;
                                    const isBeingSubstituted = editOrder.subscriber.some(
                                        s => s.isSubstitute && String(s.isSubstitute) === String(sub.id)
                                    );
                                    return !isBeingSubstituted;
                                });
                            }
                            // Só exibe o campo se houver pelo menos um elegível
                            if (elegiveis.length === 0) return null;
                            return (
                                <>
                                    <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                                        <InputLabel id="subscriber-para-substituir-label">Escolha o inscrito a associar o substituto</InputLabel>
                                        <Select
                                            labelId="subscriber-para-substituir-label"
                                            value={subscriberParaSubstituir ?? ''}
                                            label="Escolha o inscrito a associar o substituto"
                                            onChange={e => setSubscriberParaSubstituir(e.target.value)}
                                        >
                                            {elegiveis.map((sub, idx) => (
                                                <MenuItem key={sub.id || idx} value={idx}>
                                                    {sub.name} - {sub.document}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <TextField
                                            label="CPF do novo inscrito"
                                            value={cpfNovoInscrito}
                                            onChange={e => setCpfNovoInscrito(maskCPF2(e.target.value))}
                                            inputProps={{ maxLength: 14 }}
                                            sx={{ width: 220 }}
                                        />
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            disabled={buscandoNovoInscrito || cpfNovoInscrito.length < 14}
                                            onClick={buscarNovoInscritoPorCPF}
                                        >
                                            Buscar
                                        </Button>
                                    </Box>
                                </>
                            )
                        })()}
                        {novoInscrito && (
                            <Box mt={2} p={2} border={1} borderColor="grey.300" borderRadius={2}>
                                <Typography variant="subtitle2">Confirme os dados do novo inscrito:</Typography>
                                <Grid container spacing={1}>
                                    <Grid item sm={3}><TextField label="Nome" value={novoInscrito.name} InputProps={{ readOnly: true }} fullWidth /></Grid>
                                    <Grid item sm={1.5}><TextField label="CPF" value={cpfNovoInscrito} InputProps={{ readOnly: true }} fullWidth /></Grid>
                                    <Grid item sm={1}><TextField label="Nascimento" value={format(parseISO(novoInscrito.birth), 'dd/MM/yyyy')} InputProps={{ readOnly: true }} fullWidth /></Grid>
                                    <Grid item sm={0.5}><TextField label="Gênero" value={novoInscrito.gender} InputProps={{ readOnly: true }} fullWidth /></Grid>
                                    <Grid item sm={2}><TextField label="Cargo" value={novoInscrito.office} InputProps={{ readOnly: true }} fullWidth /></Grid>
                                    <Grid item sm={2}><TextField label="Email" value={novoInscrito.email} InputProps={{ readOnly: true }} fullWidth /></Grid>
                                    <Grid item sm={1.5}><TextField label="Whatsapp" value={novoInscrito.whatsapp} InputProps={{ readOnly: true }} fullWidth /></Grid>
                                </Grid>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={adicionarInscritoSubstitutoCPF}
                                >
                                    Confirmar substituição
                                </Button>
                            </Box>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ mb: 4, mr: 4 }}>
                    <Button variant='outlined' onClick={() => setDialogOpen(false)} color="error">Cancelar</Button>
                    {basePath == 'agip' || basePath == 'semper' ?
                        <Button variant='outlined' onClick={() => updateOrder()} color="success">Atualizar</Button>
                        :
                        <Button variant='contained' onClick={handleUpdateOrder} color="success">Atualizar</Button>
                    }

                </DialogActions>
            </Dialog>
            <Dialog open={openExportDialog} onClose={() => setOpenExportDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Exportar eventos selecionados</DialogTitle>
                <DialogContent>
                    <Autocomplete
                        multiple
                        options={events}
                        getOptionLabel={option => option.attributes.name}
                        value={selectedEventsToExport}
                        onChange={(_, value) => setSelectedEventsToExport(value)}
                        renderInput={(params) => (
                            <TextField {...params} label="Selecione os eventos" variant="outlined" />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenExportDialog(false)} color="inherit">Cancelar</Button>
                    <Button
                        onClick={async () => {
                            await handleExportMultipleEvents(selectedEventsToExport);
                            setOpenExportDialog(false);
                        }}
                        color="success"
                        variant="contained"
                        disabled={selectedEventsToExport.length === 0}
                    >
                        Exportar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={deleteStatus}
                aria-describedby="edit-dialog" >
                <DialogTitle>{"Deletar Pedido de Inscrição"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>Deseja mesmo deletar o pedido de inscrição?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={() => setDeleteStatus(false)} color="warning">Cancelar</Button>
                    <Button variant='outlined' onClick={() => deleteOrder()} color="error">Deletar</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openStatesDialog} onClose={() => setOpenStatesDialog(false)} maxWidth="md" fullWidth>
                <DialogTitle>Inscrições por Estado</DialogTitle>
                <DialogContent>
                    <Box sx={{ height: Math.max(300, allStatesList.length * 24) }}>
                        <Bar
                            data={allStatesBarData}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: { display: false },
                                    tooltip: {
                                        callbacks: {
                                            label: ctx => `Inscrições: ${ctx.parsed.y}`
                                        }
                                    }
                                },
                                scales: {
                                    x: {
                                        beginAtZero: true,
                                        ticks: { precision: 0 }
                                    }
                                }
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenStatesDialog(false)} color="primary">Fechar</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={confirmBoletoDialog}
                onClose={() => setConfirmBoletoDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Confirmação de Alteração de Plano
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Typography variant="body1" gutterBottom>
                            Você está alterando o plano de inscrição:
                            <br /><br />
                            <strong>De:</strong> {planChangeData?.oldPlan?.attributes?.type} - {
                                planChangeData?.oldPlan?.attributes?.price?.toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                })
                            }
                            <br />
                            <strong>Para:</strong> {planChangeData?.newPlan?.attributes?.type} - {
                                planChangeData?.newPlan?.attributes?.price?.toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                })
                            }
                            <br /><br />
                            <strong>{planChangeData?.newPlan?.attributes?.price > 0 && "Esta alteração irá gerar um novo boleto. Deseja continuar?"}</strong>
                            <strong>{planChangeData?.newPlan?.attributes?.price == 0 && "Esta alteração irá mudar o status para PAGO com valor GRATUITO. Deseja continuar?"}</strong>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setConfirmBoletoDialog(false);
                            setPlanChangeData(null);
                        }}
                        color="inherit"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={async () => {
                            if (planChangeData) {
                                await updateOrderPlan(selectedOrder.id, editOrder);
                                setStateAlert({
                                    status: true,
                                    type: 'success',
                                    msg: 'Plano atualizado e novo boleto gerado com sucesso!'
                                });
                                setConfirmBoletoDialog(false);
                                setPlanChangeData(null);
                                setDialogOpen(false);
                                await handleSearch();
                            }
                        }}
                        color="warning"
                        variant="contained"
                        autoFocus
                    >
                        Confirmar e Gerar Novo Boleto
                    </Button>
                </DialogActions>
            </Dialog>
        </Box >
    )
}

